(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[629],{

/***/ 17001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Heading; }
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./functions/createMarkup.js
var createMarkup = __webpack_require__(4089);
;// CONCATENATED MODULE: ./components/atoms/Heading/Heading.js



/**
 * Render the Heading component.
 *
 * @param  {object}  props           The props object.
 * @param  {string}  props.children  The elements or text you'd like to render inside the heading.
 * @param  {string}  props.className The optional classname.
 * @param  {string}  props.id        The optional ID.
 * @param  {object}  props.style     The style attributes.
 * @param  {string}  props.tag       The tag name you'd like the heading to render as.
 * @return {Element}                 The Heading element.
 */ function Heading(param) {
    var children = param.children, className = param.className, id = param.id, style = param.style, tag = param.tag;
    if (typeof children === "string") {
        return /*#__PURE__*/ react.createElement(tag, {
            className: className,
            id: id,
            style: style,
            dangerouslySetInnerHTML: (0,createMarkup/* default */.Z)(children)
        });
    } else {
        return /*#__PURE__*/ react.createElement(tag, {
            className: className,
            id: id,
            style: style
        }, children);
    }
}
Heading.propTypes = {
    children: prop_types_default().oneOfType([
        (prop_types_default()).node,
        (prop_types_default()).string
    ]),
    className: (prop_types_default()).string,
    id: (prop_types_default()).string,
    style: (prop_types_default()).object,
    tag: prop_types_default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ])
};
Heading.defaultProps = {
    tag: "h1"
};

;// CONCATENATED MODULE: ./components/atoms/Heading/index.js



/***/ }),

/***/ 96184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Label; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/atoms/Button/index.ts
var Button = __webpack_require__(32728);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts
var Container = __webpack_require__(691);
// EXTERNAL MODULE: ./components/atoms/Label/Label.module.scss
var Label_module = __webpack_require__(88745);
var Label_module_default = /*#__PURE__*/__webpack_require__.n(Label_module);
;// CONCATENATED MODULE: ./components/atoms/Label/Label.tsx





function Label(param) {
    var title = param.title, link = param.link, isSmall = param.isSmall, removeBorders = param.removeBorders, hasParent = param.hasParent;
    var element = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Label_module_default()).titleWrapper, isSmall ? (Label_module_default()).isSmall : "", !hasParent ? (Label_module_default()).paddingTop : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Label_module_default()).title, isSmall ? (Label_module_default()).isSmall : ""),
                children: title
            }),
            (link === null || link === void 0 ? void 0 : link.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (Label_module_default()).button,
                type: "blue",
                text: link.title,
                url: link.url,
                urlExternal: link.target
            })
        ]
    });
    if (hasParent) return element;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        removeBorders: removeBorders,
        children: element
    });
}

;// CONCATENATED MODULE: ./components/atoms/Label/index.ts



/***/ }),

/***/ 23566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ RelatedPosts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/blocks/custom/RelatedPosts/RelatedPosts.module.scss
var RelatedPosts_module = __webpack_require__(20717);
var RelatedPosts_module_default = /*#__PURE__*/__webpack_require__.n(RelatedPosts_module);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts
var Container = __webpack_require__(691);
// EXTERNAL MODULE: ./components/atoms/Icon/index.ts
var Icon = __webpack_require__(16372);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/atoms/Label/index.ts + 1 modules
var Label = __webpack_require__(96184);
// EXTERNAL MODULE: ./functions/utils.js
var utils = __webpack_require__(75265);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./components/blocks/custom/RelatedPosts/RelatedPosts.tsx













function Arrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (RelatedPosts_module_default()).circle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                icon: "sliderArrow",
                size: 40,
                sizeViewbox: 40
            })
        })
    });
}
function RelatedPosts(param) {
    var block = param.block;
    var ref, ref1, ref2;
    var title = block.title;
    var router = (0,next_router.useRouter)();
    var posts = block === null || block === void 0 ? void 0 : (ref = block.posts) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.posts) === null || ref2 === void 0 ? void 0 : ref2.nodes;
    var sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        arrows: true,
        draggable: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {}),
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    arrows: true,
                    draggable: true,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1132,
                settings: {
                    arrows: true,
                    draggable: true,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: true,
                    draggable: true,
                    slidesToShow: 1
                }
            }
        ]
    };
    return (posts === null || posts === void 0 ? void 0 : posts.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((RelatedPosts_module_default()).relatedPostsWrapper, (posts === null || posts === void 0 ? void 0 : posts.length) <= 3 ? (RelatedPosts_module_default()).noSliderButtons : ""),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-aos": "fade-in",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                    title: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RelatedPosts_module_default()).sliderWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                        children: posts.map(function(post, index) {
                            var ref, ref1, ref2, ref3;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: (RelatedPosts_module_default()).slide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        post.featuredImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                return router.push("/news/".concat(post.slug));
                                            },
                                            className: (RelatedPosts_module_default()).slideImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (ref = post.featuredImage) === null || ref === void 0 ? void 0 : ref.node.mediaItemUrl,
                                                alt: (ref1 = post.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.node.altText,
                                                width: (ref2 = post.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.node.mediaDetails.width,
                                                height: (ref3 = post.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.node.mediaDetails.height,
                                                layout: "responsive",
                                                objectFit: "cover",
                                                priority: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (RelatedPosts_module_default()).textWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RelatedPosts_module_default()).date,
                                                    children: (0,utils/* formatDate */.p)(post.date)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/news/".concat(post.slug),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (RelatedPosts_module_default()).slideTitle,
                                                        children: post.title
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }))
                })
            })
        ]
    }) : null;
}

;// CONCATENATED MODULE: ./components/blocks/custom/RelatedPosts/index.ts



/***/ }),

/***/ 50377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Blocks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/Button/index.ts
var Button = __webpack_require__(32728);
;// CONCATENATED MODULE: ./functions/wordpress/blocks/getBlockStyles.js
/**
 * Get formatted block styles.
 *
 * @author WebDevStudios
 * @param  {object}          styles                    Various block custom and preset styles.
 * @param  {string}          styles.backgroundColorHex The background color hex value.
 * @param  {string}          styles.gradientHex        The background gradient hex value.
 * @param  {string}          styles.textColorHex       The text color hex value.
 * @param  {number | string} styles.width              The block width.
 * @param  {object}          styles.style              The style attributes.
 * @return {object}                                    The formatted style object.
 */ function getBlockStyles(param) {
    var backgroundColorHex = param.backgroundColorHex, gradientHex = param.gradientHex, textColorHex = param.textColorHex, width = param.width, style = param.style;
    var ref, ref1, ref2, ref3, ref4;
    var blockStyle = {};
    // Determine styles, using stylelint-accepted const names.
    var background = gradientHex || (style === null || style === void 0 ? void 0 : (ref = style.color) === null || ref === void 0 ? void 0 : ref.gradient);
    var backgroundcolor = backgroundColorHex || (style === null || style === void 0 ? void 0 : (ref1 = style.color) === null || ref1 === void 0 ? void 0 : ref1.background);
    var fontsize = style === null || style === void 0 ? void 0 : (ref2 = style.typography) === null || ref2 === void 0 ? void 0 : ref2.fontSize;
    var fontweight = style === null || style === void 0 ? void 0 : (ref3 = style.typography) === null || ref3 === void 0 ? void 0 : ref3.fontWeight;
    var textcolor = textColorHex || (style === null || style === void 0 ? void 0 : (ref4 = style.color) === null || ref4 === void 0 ? void 0 : ref4.text);
    // Only add styles if set.
    if (background) {
        blockStyle.background = background;
    }
    if (backgroundcolor) {
        blockStyle.backgroundColor = backgroundcolor;
    }
    if (fontsize) {
        blockStyle.fontSize = fontsize;
    }
    if (fontweight) {
        blockStyle.fontWeight = fontweight;
    }
    if (textcolor) {
        blockStyle.color = textcolor;
    }
    if (width) {
        if (isNaN(width)) {
            // If width is not a number, return full string.
            blockStyle.width = width;
        } else {
            // If width is a number, return as percent.
            blockStyle.width = "".concat(width, "%");
        }
    }
    return blockStyle;
}

;// CONCATENATED MODULE: ./components/blocks/core/BlockButton/BlockButton.js




/**
 * Button Block
 *
 * The core Button block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component properties.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.backgroundColorHex The background color hex value.
 * @param  {number}  props.borderRadius       The border radius in pixels.
 * @param  {string}  props.className          Optional classnames.
 * @param  {string}  props.gradientHex        The background gradient hex value.
 * @param  {string}  props.linkTarget         The target for the link.
 * @param  {string}  props.rel                The rel attribute for the link.
 * @param  {object}  props.style              The style attributes.
 * @param  {string}  props.text               The link label.
 * @param  {string}  props.textColorHex       The text color hex value.
 * @param  {string}  props.url                The link for the button.
 * @param  {boolean} props.urlExternal        Whether link is external.
 * @param  {number}  props.width              The width in percent.
 * @return {Element}                          The Button component.
 */ function BlockButton(param) {
    var anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, borderRadius = param.borderRadius, className = param.className, gradientHex = param.gradientHex, linkTarget = param.linkTarget, rel = param.rel, style = param.style, text = param.text, textColorHex = param.textColorHex, url = param.url, urlExternal = param.urlExternal, width = param.width;
    var buttonStyle = getBlockStyles({
        backgroundColorHex: backgroundColorHex,
        gradientHex: gradientHex,
        textColorHex: textColorHex,
        width: width,
        style: style
    });
    // Add additional styles.
    if (borderRadius) {
        buttonStyle.borderRadius = "".concat(borderRadius, "px");
    }
    // Extract button style.
    var styleOutline = className && className.includes("is-style-outline");
    // Remove styles from className.
    className && className.replace("is-style-outline", "").replace("is-style-fill", "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        attributes: {
            id: anchor || null,
            target: linkTarget || null,
            rel: rel || null
        },
        className: className,
        style: buttonStyle,
        styleOutline: styleOutline,
        text: text,
        url: url,
        urlExternal: urlExternal
    });
}
BlockButton.propTypes = {
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    borderRadius: (prop_types_default()).number,
    className: (prop_types_default()).string,
    gradientHex: (prop_types_default()).string,
    linkTarget: (prop_types_default()).string,
    rel: (prop_types_default()).string,
    style: (prop_types_default()).object,
    text: (prop_types_default()).string,
    textColorHex: (prop_types_default()).string,
    url: (prop_types_default()).string,
    urlExternal: (prop_types_default()).bool,
    width: (prop_types_default()).number
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockButton/index.js


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/molecules/ButtonGroup/ButtonGroup.module.css
var ButtonGroup_module = __webpack_require__(27458);
var ButtonGroup_module_default = /*#__PURE__*/__webpack_require__.n(ButtonGroup_module);
;// CONCATENATED MODULE: ./components/molecules/ButtonGroup/ButtonGroup.js





/**
 * Render the ButtonGroup component.
 *
 * @author WebDevStudios
 * @param  {object}  props                      The component properties.
 * @param  {Element} props.children             The children props to render.
 * @param  {string}  props.contentJustification The justification of the buttons.
 * @param  {string}  props.id                   The id of the block.
 * @param  {string}  props.orientation          The orientation of buttons.
 * @return {Element}                            The ButtonGroup component.
 */ function ButtonGroup(param) {
    var children = param.children, contentJustification = param.contentJustification, id = param.id, orientation = param.orientation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: id || null,
            className: classnames_default()((ButtonGroup_module_default()).buttonGroup, (ButtonGroup_module_default())[orientation], (ButtonGroup_module_default())[contentJustification]),
            children: children
        })
    });
}
ButtonGroup.propTypes = {
    children: (prop_types_default()).element,
    contentJustification: (prop_types_default()).string,
    id: (prop_types_default()).string,
    orientation: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/molecules/ButtonGroup/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockButtons/BlockButtons.js




/**
 * Buttons Block
 *
 * The core Buttons block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                      The component properties.
 * @param  {string}  props.anchor               Optional anchor/id.
 * @param  {string}  props.contentJustification The justification of the buttons.
 * @param  {Array}   props.innerBlocks          The array of inner blocks to display.
 * @param  {string}  props.orientation          The orientation of buttons.
 * @return {Element}                            The Buttons component.
 */ function BlockButtons(param) {
    var anchor = param.anchor, contentJustification = param.contentJustification, innerBlocks = param.innerBlocks, orientation = param.orientation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
        id: anchor,
        orientation: orientation,
        contentJustification: contentJustification,
        children: !!(innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks, {
            blocks: innerBlocks
        })
    });
}
BlockButtons.propTypes = {
    anchor: (prop_types_default()).string,
    contentJustification: (prop_types_default()).string,
    innerBlocks: prop_types_default().arrayOf(prop_types_default().shape({
        name: (prop_types_default()).string,
        attributes: (prop_types_default()).object
    })),
    orientation: (prop_types_default()).string
};
BlockButtons.defaultProps = {
    options: prop_types_default().shape({
        orientation: "horizontal",
        contentJustification: "left"
    })
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockButtons/index.js


// EXTERNAL MODULE: ./components/atoms/Code/index.js + 18 modules
var Code = __webpack_require__(27671);
;// CONCATENATED MODULE: ./components/blocks/core/BlockCode/BlockCode.js




/**
 * Code Block
 *
 * The core Code block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component props.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.backgroundColorHex The background color hex value.
 * @param  {string}  props.className          Optional classnames.
 * @param  {string}  props.content            The content of the block.
 * @param  {string}  props.gradientHex        The background gradient hex value.
 * @param  {object}  props.style              The style attributes (Typography panel).
 * @param  {string}  props.textColorHex       The text color hex value.
 * @return {Element}                          The Code component.
 */ function BlockCode(param) {
    var anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, className = param.className, content = param.content, gradientHex = param.gradientHex, style = param.style, textColorHex = param.textColorHex;
    var codeStyle = getBlockStyles({
        backgroundColorHex: backgroundColorHex,
        gradientHex: gradientHex,
        textColorHex: textColorHex,
        style: style
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Code/* default */.Z, {
        className: className,
        id: anchor,
        content: content,
        style: codeStyle
    });
}
BlockCode.propTypes = {
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    content: (prop_types_default()).string,
    className: (prop_types_default()).string,
    gradientHex: (prop_types_default()).string,
    style: (prop_types_default()).object,
    textColorHex: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockCode/index.js


// EXTERNAL MODULE: ./components/atoms/Columns/Columns.module.css
var Columns_module = __webpack_require__(73718);
var Columns_module_default = /*#__PURE__*/__webpack_require__.n(Columns_module);
;// CONCATENATED MODULE: ./components/atoms/Columns/Columns.js





/**
 * Render the Columns component.
 *
 * @param  {object}  props                   Container component props.
 * @param  {string}  props.id                Optional ID/Anchor.
 * @param  {string}  props.className         Optional className.
 * @param  {string}  props.columnCount       Total number of columns.
 * @param  {object}  props.children          React children.
 * @param  {object}  props.style             Custom columns styles.
 * @param  {string}  props.verticalAlignment Vertical alignment of columns.
 * @param  {boolean} props.isStackedOnMobile Checks if the columns are stacked.
 * @return {Element}                         The Columns component.
 */ function Columns(param) {
    var id = param.id, className = param.className, columnCount = param.columnCount, children = param.children, style = param.style, verticalAlignment = param.verticalAlignment, isStackedOnMobile = param.isStackedOnMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id || null,
        className: classnames_default()((Columns_module_default()).columns, isStackedOnMobile && (Columns_module_default()).columnStacked, columnCount && (Columns_module_default())["columns-".concat(columnCount)], className, verticalAlignment === "center" ? (Columns_module_default()).alignCenter : null, verticalAlignment === "bottom" ? (Columns_module_default()).alignBottom : null, (style === null || style === void 0 ? void 0 : style.background) || (style === null || style === void 0 ? void 0 : style.backgroundColor) ? (Columns_module_default()).hasBackground : null),
        style: style,
        children: !!children && !!(children === null || children === void 0 ? void 0 : children.length) && react.Children.map(children, function(column) {
            var ref, ref1, ref2, ref3;
            // Create copy of child column to add custom classes.
            var newColumn = /*#__PURE__*/ react.cloneElement(column, {
                className: classnames_default()(column === null || column === void 0 ? void 0 : column.className, (Columns_module_default()) === null || (Columns_module_default()) === void 0 ? void 0 : (Columns_module_default()).column, (column === null || column === void 0 ? void 0 : (ref = column.props) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : ref1.background) || (column === null || column === void 0 ? void 0 : (ref2 = column.props) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.style) === null || ref3 === void 0 ? void 0 : ref3.backgroundColor) ? (Columns_module_default()).hasBackground : null)
            });
            return newColumn;
        })
    });
}
Columns.propTypes = {
    id: (prop_types_default()).string,
    className: (prop_types_default()).string,
    columnCount: (prop_types_default()).number,
    children: (prop_types_default()).node,
    style: prop_types_default().shape({
        background: (prop_types_default()).string,
        backgroundColor: (prop_types_default()).string,
        color: (prop_types_default()).string
    }),
    verticalAlignment: (prop_types_default()).string
};
Columns.defaultProps = {
    columnCount: 3
};

;// CONCATENATED MODULE: ./components/atoms/Columns/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockColumns/BlockColumns.js





/**
 * Columns Block
 *
 * The core Columns block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component properties.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.backgroundColorHex The background color hex value.
 * @param  {string}  props.className          Optional classnames.
 * @param  {string}  props.gradientHex        The background gradient hex value.
 * @param  {object}  props.innerBlocks        The array of inner blocks to display.
 * @param  {object}  props.style              The style attributes.
 * @param  {string}  props.textColorHex       The text color hex value.
 * @param  {boolean} props.isStackedOnMobile  Checks if the columns are stacked.
 * @param  {string}  props.verticalAlignment  Vertical alignment of columns.
 * @return {Element}                          The Columns component.
 */ function BlockColumns(param) {
    var anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, className = param.className, gradientHex = param.gradientHex, innerBlocks = param.innerBlocks, style = param.style, textColorHex = param.textColorHex, verticalAlignment = param.verticalAlignment, isStackedOnMobile = param.isStackedOnMobile;
    var columnsStyle = getBlockStyles({
        backgroundColorHex: backgroundColorHex,
        gradientHex: gradientHex,
        textColorHex: textColorHex,
        style: style
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!(innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns, {
            id: anchor,
            className: className,
            columnCount: innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length,
            style: columnsStyle,
            verticalAlignment: verticalAlignment,
            isStackedOnMobile: isStackedOnMobile,
            children: innerBlocks.map(function(param, index) {
                var attributes = param.attributes, innerBlocks = param.innerBlocks;
                var columnStyle = getBlockStyles({
                    backgroundColorHex: attributes === null || attributes === void 0 ? void 0 : attributes.backgroundColorHex,
                    gradientHex: attributes === null || attributes === void 0 ? void 0 : attributes.gradientHex,
                    textColorHex: attributes === null || attributes === void 0 ? void 0 : attributes.textColorHex,
                    style: attributes === null || attributes === void 0 ? void 0 : attributes.style,
                    width: attributes === null || attributes === void 0 ? void 0 : attributes.width
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: attributes === null || attributes === void 0 ? void 0 : attributes.anchor,
                    className: attributes === null || attributes === void 0 ? void 0 : attributes.className,
                    style: columnStyle,
                    children: !!(innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks, {
                        blocks: innerBlocks
                    })
                }, "column-".concat(index));
            })
        })
    });
}
BlockColumns.propTypes = {
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    className: (prop_types_default()).string,
    gradientHex: (prop_types_default()).string,
    innerBlocks: prop_types_default().arrayOf(prop_types_default().shape({
        block: (prop_types_default()).object,
        index: (prop_types_default()).number
    })),
    style: (prop_types_default()).object,
    textColorHex: (prop_types_default()).string,
    verticalAlignment: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockColumns/index.js


;// CONCATENATED MODULE: ./functions/convertHextoRgb.js
/**
 * Convert a hex color value to RGB.
 *
 * @see https://stackoverflow.com/a/39077686
 * @author WebDevStudios
 * @param  {string} hexValue Hex color value.
 * @return {Array}           RGB color value as array.
 */ function convertHextoRgb(hexValue) {
    return hexValue.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(_, r, g, b) {
        return "#" + r + r + g + g + b + b;
    }).substring(1).match(/.{2}/g).map(function(x) {
        return parseInt(x, 16);
    });
}

;// CONCATENATED MODULE: ./functions/extractRgbValues.js
/**
 * Extract numeric RGB values from string.
 *
 * @see https://stackoverflow.com/a/34980657
 * @author WebDevStudios
 * @param  {string} rgbString RGB string.
 * @return {Array}            Array of numeric RGB values.
 */ function extractRgbValues(rgbString) {
    var rgbValues = rgbString.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?/);
    // Remove first element (original RGB string).
    rgbValues.shift();
    return rgbValues;
}

// EXTERNAL MODULE: ./components/organisms/Hero/Hero.module.css
var Hero_module = __webpack_require__(19129);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./components/organisms/Hero/Hero.js









/**
 * Render the DuotoneFilter component.
 *
 * @author WebDevStudios
 * @param  {object}  props           Component props.
 * @param  {string}  props.className The className.
 * @param  {Array}   props.duotone   Array of duotone color values.
 * @param  {string}  props.id        Unique filter ID.
 * @return {Element}                 The DuotoneFilter component.
 */ function DuotoneFilter(param) {
    var className = param.className, duotone = param.duotone, id = param.id;
    var rgbValues = (duotone === null || duotone === void 0 ? void 0 : duotone.length) && duotone.map(function(color) {
        return color.indexOf("#") !== -1 ? convertHextoRgb(color) : extractRgbValues(color);
    });
    // Calculate R, G, B decimal values.
    var rValues = rgbValues.map(function(color) {
        return color[0] / 255;
    });
    var gValues = rgbValues.map(function(color) {
        return color[1] / 255;
    });
    var bValues = rgbValues.map(function(color) {
        return color[2] / 255;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                id: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                        type: "matrix",
                        values: ".299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 0 0 0 1 0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("feComponentTransfer", {
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFuncR", {
                                type: "table",
                                tableValues: rValues.join(" ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFuncG", {
                                type: "table",
                                tableValues: gValues.join(" ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFuncB", {
                                type: "table",
                                tableValues: bValues.join(" ")
                            })
                        ]
                    })
                ]
            })
        })
    });
}
DuotoneFilter.propTypes = {
    className: (prop_types_default()).string,
    duotone: (prop_types_default()).array,
    id: (prop_types_default()).string
};
/**
 * Render the Hero component.
 *
 * @param  {object}  props                 Hero component props.
 * @param  {string}  props.align           The alignment of the hero component.
 * @param  {string}  props.backgroundImage The background image object.
 * @param  {string}  props.body            Text for the body.
 * @param  {string}  props.className       The className.
 * @param  {any}     props.children        InnerBlocks.
 * @param  {string}  props.contentAlign    The alignment of the component content.
 * @param  {object}  props.ctaText         The cta text.
 * @param  {object}  props.ctaUrl          The cta url.
 * @param  {Array}   props.duotone         Array of duotone color values.
 * @param  {boolean} props.fixed           Whether the background is fixed (parallax).
 * @param  {object}  props.focalPoint      The focal point coordinates for the image.
 * @param  {boolean} props.fullHeight      Whether hero is full height.
 * @param  {string}  props.id              Optional element ID.
 * @param  {number}  props.overlayOpacity  The overlay opacity as a float.
 * @param  {boolean} props.repeat          Whether background is repeated.
 * @param  {object}  props.style           Custom hero styles.
 * @param  {string}  props.subtitle        Text for the subtitle.
 * @param  {string}  props.title           Text for the title.
 * @return {Element}                       The Hero component.
 */ function Hero(param) {
    var align = param.align, backgroundImage = param.backgroundImage, body = param.body, className = param.className, children = param.children, contentAlign = param.contentAlign, ctaText = param.ctaText, ctaUrl = param.ctaUrl, duotone = param.duotone, fixed = param.fixed, focalPoint = param.focalPoint, fullHeight = param.fullHeight, id = param.id, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 0.5 : _overlayOpacity, repeat = param.repeat, style = param.style, subtitle = param.subtitle, title = param.title;
    var heroStyle = (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url) ? {
        // These css custom properties are used inside the css module file to set the card's background image, tint overlay, and fallback bg color.
        "--image-url": "url(".concat(backgroundImage.url, ")"),
        "--image-tint-color": "#00000000",
        "--image-fallback-color": "#000"
    } : {};
    // Rename to stylelint-accepted const name.
    var overlayopacity = overlayOpacity;
    var hasFilter = !!(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url) && !!duotone && !fixed && !repeat;
    // Generate unique ID for filter.
    var filterKey = Math.random().toString(36).substr(2, 9);
    var filterId = "duotone-filter-".concat(filterKey);
    var filterStyle = {
        filter: "url(#".concat(filterId, ")")
    };
    // Conditionally apply focal point.
    if (focalPoint) {
        var focalPointStyle = "".concat(focalPoint.x, " ").concat(focalPoint.y);
        heroStyle.backgroundPosition = focalPointStyle;
        filterStyle.objectPosition = focalPointStyle;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(DuotoneFilter, {
                className: (Hero_module_default()).filter,
                duotone: duotone,
                id: filterId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: id,
                className: classnames_default()((Hero_module_default()).hero, className, align === "left" ? (Hero_module_default()).alignLeft : null, align === "right" ? (Hero_module_default()).alignRight : null, contentAlign && contentAlign.indexOf("top") === 0 ? (Hero_module_default()).contentAlignTop : null, contentAlign && contentAlign.indexOf("bottom") === 0 ? (Hero_module_default()).contentAlignBottom : null, contentAlign && contentAlign.indexOf("left") > -1 ? (Hero_module_default()).contentAlignLeft : null, contentAlign && contentAlign.indexOf("right") > -1 ? (Hero_module_default()).contentAlignRight : null, fixed ? (Hero_module_default()).fixed : null, fullHeight ? (Hero_module_default()).fullHeight : null, repeat ? (Hero_module_default()).repeat : null),
                style: (0,_object_spread/* default */.Z)({}, style, heroStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Hero_module_default()).overlay, !(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url) ? (Hero_module_default()).overlayOnly : null),
                        style: {
                            opacity: overlayopacity
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Hero_module_default()).content,
                        children: [
                            !!subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Hero_module_default()).subtitle,
                                children: subtitle
                            }),
                            !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (Hero_module_default()).title,
                                children: title
                            }),
                            !!body && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Hero_module_default()).body,
                                children: body
                            }),
                            !!ctaText && ctaUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (Hero_module_default()).button,
                                url: ctaUrl,
                                text: ctaText,
                                icon: "arrowRight",
                                type: "primary",
                                size: "md"
                            })
                        ]
                    }),
                    hasFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        className: (Hero_module_default()).filterImage,
                        src: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url,
                        style: filterStyle
                    }),
                    children
                ]
            })
        ]
    });
}
Hero.propTypes = {
    align: (prop_types_default()).string,
    backgroundImage: (prop_types_default()).object,
    body: (prop_types_default()).string,
    className: (prop_types_default()).string,
    children: (prop_types_default()).any,
    contentAlign: (prop_types_default()).string,
    ctaText: (prop_types_default()).string,
    ctaUrl: (prop_types_default()).string,
    duotone: (prop_types_default()).array,
    fixed: (prop_types_default()).bool,
    focalPoint: prop_types_default().shape({
        x: (prop_types_default()).string,
        y: (prop_types_default()).string
    }),
    fullHeight: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    overlayOpacity: (prop_types_default()).number,
    repeat: (prop_types_default()).bool,
    style: (prop_types_default()).object,
    subtitle: (prop_types_default()).string,
    title: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/organisms/Hero/index.js


;// CONCATENATED MODULE: ./functions/formatFocalPoint.js
/**
 * Parse and format focal point coordinates into percent.
 *
 * @author WebDevStudios
 * @param  {object} focalPoint The focal point coordinats.
 * @return {object}            Formatted focal point coordinates for styling.
 */ function formatFocalPoint(focalPoint) {
    var newFocalPoint = {};
    var x = focalPoint === null || focalPoint === void 0 ? void 0 : focalPoint.x;
    var y = focalPoint === null || focalPoint === void 0 ? void 0 : focalPoint.y;
    var ref;
    x = (ref = parseFloat(x && !isNaN(x) ? x : ".5")) !== null && ref !== void 0 ? ref : 0.5;
    var ref1;
    y = (ref1 = parseFloat(y && !isNaN(y) ? y : ".5")) !== null && ref1 !== void 0 ? ref1 : 0.5;
    newFocalPoint.x = "".concat(x * 100, "%");
    newFocalPoint.y = "".concat(y * 100, "%");
    return newFocalPoint;
}

;// CONCATENATED MODULE: ./components/blocks/core/BlockCover/BlockCover.js








/**
 * Cover Block
 *
 * The core Columns block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                 The component properties.
 * @param  {string}  props.align           Optional alignment style.
 * @param  {string}  props.anchor          Optional anchor/id.
 * @param  {string}  props.className       Optional classnames.
 * @param  {string}  props.contentPosition The alignment of the component content.
 * @param  {string}  props.customGradient  The custom gradient color.
 * @param  {number}  props.dimRatio        The overlay dim ratio.
 * @param  {object}  props.focalPoint      The focal point coordinates for the image.
 * @param  {string}  props.gradientHex     The background gradient hex value.
 * @param  {boolean} props.hasParallax     Whether image has parallex.
 * @param  {Array}   props.innerBlocks     The array of inner blocks to display.
 * @param  {boolean} props.isRepeated      Whether image is repeated.
 * @param  {number}  props.minHeight       The image minimum height.
 * @param  {string}  props.minHeightUnit   The image minimum height unit.
 * @param  {string}  props.overlayColorHex The overlay color hex value.
 * @param  {object}  props.style           The style attributes.
 * @param  {string}  props.url             The image src attribute.
 * @return {Element}                       The Cover component.
 */ function BlockCover(param) {
    var align = param.align, anchor = param.anchor, className = param.className, contentPosition = param.contentPosition, customGradient = param.customGradient, dimRatio = param.dimRatio, focalPoint = param.focalPoint, gradientHex = param.gradientHex, hasParallax = param.hasParallax, innerBlocks = param.innerBlocks, isRepeated = param.isRepeated, minHeight = param.minHeight, minHeightUnit = param.minHeightUnit, overlayColorHex = param.overlayColorHex, style = param.style, url = param.url;
    var ref;
    var overlayColor = overlayColorHex || "#000000";
    var overlayGradient = customGradient || gradientHex;
    var overlayOpacity = url ? dimRatio / 100 : 1;
    // Add custom styles for Hero.
    var coverStyle = {};
    if (overlayColor && !overlayGradient) {
        coverStyle.backgroundColor = overlayColor;
    }
    if (overlayGradient) {
        coverStyle.background = overlayGradient;
    }
    if (minHeight && minHeightUnit !== "vh") {
        coverStyle.minHeight = "".concat(minHeight, "px");
    }
    var newFocalPoint = formatFocalPoint(focalPoint);
    var ref1 = (0,react.useState)(), newInnerBlocks = ref1[0], setInnerBlocks = ref1[1];
    // Add extra class(es) to inner blocks on initial load.
    (0,react.useEffect)(function() {
        setInnerBlocks(!(innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length) ? [] : innerBlocks.map(function(block) {
            var ref, ref1;
            var ref2;
            var classes = ((ref2 = block === null || block === void 0 ? void 0 : (ref = block.attributes) === null || ref === void 0 ? void 0 : ref.className) !== null && ref2 !== void 0 ? ref2 : "").split(" ");
            // Extra check to only add class once.
            if (classes.includes("relative")) {
                return block;
            }
            block.attributes = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, block === null || block === void 0 ? void 0 : block.attributes), {
                className: "".concat((block === null || block === void 0 ? void 0 : (ref1 = block.attributes) === null || ref1 === void 0 ? void 0 : ref1.className) || "", " relative z-10")
            });
            return block;
        }));
    }, [
        innerBlocks
    ]);
    // Only proceed if we're provided a media URL or a user-selected overlay color/gradient.
    if (!url && !overlayColorHex && !overlayGradient) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
        align: align,
        contentAlign: contentPosition,
        backgroundImage: {
            url: url
        },
        className: className,
        duotone: style === null || style === void 0 ? void 0 : (ref = style.color) === null || ref === void 0 ? void 0 : ref.duotone,
        fixed: hasParallax,
        focalPoint: newFocalPoint,
        fullHeight: minHeight === 100 && minHeightUnit === "vh",
        id: anchor,
        overlayOpacity: overlayOpacity,
        repeat: isRepeated,
        style: coverStyle,
        children: !!(newInnerBlocks === null || newInnerBlocks === void 0 ? void 0 : newInnerBlocks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks, {
            blocks: newInnerBlocks
        })
    });
}
BlockCover.propTypes = {
    align: (prop_types_default()).string,
    anchor: (prop_types_default()).string,
    className: (prop_types_default()).string,
    contentPosition: (prop_types_default()).string,
    customGradient: (prop_types_default()).string,
    dimRatio: (prop_types_default()).number,
    focalPoint: prop_types_default().shape({
        x: (prop_types_default()).string,
        y: (prop_types_default()).string
    }),
    gradientHex: (prop_types_default()).string,
    hasParallax: (prop_types_default()).bool,
    innerBlocks: prop_types_default().arrayOf(prop_types_default().shape({
        name: (prop_types_default()).string,
        attributes: (prop_types_default()).object
    })),
    isRepeated: (prop_types_default()).bool,
    minHeight: (prop_types_default()).number,
    minHeightUnit: (prop_types_default()).string,
    overlayColorHex: (prop_types_default()).string,
    style: (prop_types_default()).object,
    url: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockCover/index.js


// EXTERNAL MODULE: ./components/atoms/RichText/index.js + 1 modules
var RichText = __webpack_require__(36091);
// EXTERNAL MODULE: ./components/atoms/VideoEmbed/VideoEmbed.module.css
var VideoEmbed_module = __webpack_require__(56491);
var VideoEmbed_module_default = /*#__PURE__*/__webpack_require__.n(VideoEmbed_module);
;// CONCATENATED MODULE: ./components/atoms/VideoEmbed/VideoEmbed.js






/**
 * VideoEmbed Block
 *
 * @author WebDevStudios
 * @param  {object}  props           VideoEmbed component props.
 * @param  {string}  props.className Optional className.
 * @param  {string}  props.url       The full URL to the video.
 * @param  {string}  props.type      The type of video (youtube, vimeo).
 * @param  {string}  props.caption   Optional caption.
 * @return {Element}                 The VideoEmbed component.
 */ function VideoEmbed(param) {
    var className = param.className, url = param.url, type = param.type, caption = param.caption;
    var createVideoUrl = /**
   * Create URL embed for YouTube or Vimeo videos.
   *
   * @param  {string} url The video URL.
   * @return {string}     Formatted video URL.
   */ function createVideoUrl(url) {
        if (!url) {
            return false;
        }
        var videoUrl, videoId;
        videoId = url.indexOf("v=") !== -1 ? url.split("v=") : url.split("/");
        videoId = videoId[videoId.length - 1];
        videoUrl = url.includes("vimeo") ? "//player.vimeo.com/video/".concat(videoId) : "//youtube.com/embed/".concat(videoId);
        return videoUrl;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((VideoEmbed_module_default()).videoEmbed, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VideoEmbed_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true,
                    frameBorder: "0",
                    height: "315",
                    loading: "lazy",
                    src: createVideoUrl(url),
                    width: "560",
                    title: "Embedded content from ".concat(type),
                    className: className
                })
            }),
            !!caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VideoEmbed_module_default()).caption,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                    tag: "span",
                    children: caption
                })
            })
        ]
    });
}
VideoEmbed.propTypes = {
    className: (prop_types_default()).string,
    caption: (prop_types_default()).string,
    type: (prop_types_default()).string,
    url: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./components/atoms/VideoEmbed/index.js


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/blocks/core/BlockEmbed/BlockEmbed.js





var Tweet = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 671).then(__webpack_require__.bind(__webpack_require__, 58671));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58671)
            ];
        }
    }
});
/**
 * Embed Block
 *
 * The core Embed block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                  The component properties.
 * @param  {string}  props.className        Optional classnames.
 * @param  {string}  props.url              The URL of the video.
 * @param  {string}  props.caption          Optional caption.
 * @param  {string}  props.providerNameSlug The type of embed.
 * @return {Element}                        The component to embed.
 */ function BlockEmbed(param) {
    var className = param.className, url = param.url, caption = param.caption, providerNameSlug = param.providerNameSlug;
    var ref = (0,react.useState)(0), loadTweet = ref[0], setLoadTweet = ref[1];
    var supportedVideoTypes = [
        "youtube",
        "vimeo"
    ];
    (0,react.useEffect)(function() {
        // Load Tweet library using Next Dynamic
        // @see https://nextjs.org/docs/advanced-features/dynamic-import
        if (providerNameSlug === "twitter") {
            setLoadTweet(1);
        }
    }, [
        providerNameSlug
    ]);
    if (!url) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!loadTweet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tweet, {
                className: className,
                url: url,
                caption: caption
            }),
            !!supportedVideoTypes.includes(providerNameSlug) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEmbed, {
                className: className,
                url: url,
                caption: caption,
                type: providerNameSlug
            })
        ]
    });
}
BlockEmbed.propTypes = {
    className: (prop_types_default()).string,
    url: (prop_types_default()).string,
    align: (prop_types_default()).string,
    caption: (prop_types_default()).string,
    providerNameSlug: (prop_types_default()).string
};
BlockEmbed.defaultProps = {
    align: "left"
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockEmbed/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
;// CONCATENATED MODULE: ./components/molecules/Form/Form.js



/**
 * Render Form component.
 *
 * @param  {object}           props                  The component attributes as props.
 * @param  {Element|Function} props.children         Form children elements.
 * @param  {string}           props.className        Form wrapper class.
 * @param  {object}           props.formDefaults     Formik default data.
 * @param  {string|number}    props.id               Form id.
 * @param  {object}           props.validationSchema Yup validation schema object.
 * @param  {Function}         props.onSubmit         Function to execute when form is submitted
 * @return {Element}                                 The Form component.
 */ function Form(param) {
    var children = param.children, className = param.className, formDefaults = param.formDefaults, id = param.id, validationSchema = param.validationSchema, onSubmit = param.onSubmit;
    var formattedChildren = children;
    if ("function" !== typeof children) {
        formattedChildren = function() {
            return children;
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: formDefaults,
        validationSchema: validationSchema,
        onSubmit: onSubmit,
        children: function(formikProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                    id: id,
                    className: className,
                    children: formattedChildren(formikProps)
                })
            });
        }
    });
}
Form.propTypes = {
    children: (prop_types_default()).any,
    className: (prop_types_default()).string,
    formDefaults: (prop_types_default()).object,
    id: (prop_types_default()).string,
    validationSchema: (prop_types_default()).object,
    onSubmit: (prop_types_default()).func
};
Form.defaultProps = {
    formDefaults: {}
};

;// CONCATENATED MODULE: ./components/molecules/Form/index.js


// EXTERNAL MODULE: ./lib/next-api/connector.js + 2 modules
var connector = __webpack_require__(90848);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./lib/next-api/wordpress/gravityForms/mutationSubmitForm.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  mutation SUBMIT_FORM(\n    $formId: Int!\n    $fieldValues: [FieldValuesInput]\n  ) {\n    formEntry (\n      input: {formId: $formId, fieldValues: $fieldValues}\n    ) @rest(\n      type: "GravityForms",\n      path: "',
        '",\n      method: "POST",\n      bodySerializer: "encodeGfFormData"\n  ) {\n      entryId\n      confirmationMessage\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// Mutation: submit GF form via frontend.
var mutationSubmitForm = (0,lib/* gql */.Ps)(_templateObject(), connector/* nextApiRoutes.wordpress.gravityForms */.PO.wordpress.gravityForms);
/* harmony default export */ var gravityForms_mutationSubmitForm = (mutationSubmitForm);

;// CONCATENATED MODULE: ./functions/next-api/wordpress/gravityForms/processGfFieldValues.js
/**
 * Process and format GF form field values for submission.
 *
 * Note: the following fields are currently unsupported in the project; if they are added, they will need custom handling for display and entry handling here:
 * - AddressField
 * - CaptchaField
 * - ChainedSelectField
 * - DateField
 * - EmailField with Email Confirmation enabled
 * - FileUploadField
 * - HiddenField
 * - ListField
 * - MultiSelectField
 * - NameField
 * - NumberField
 * - RadioField
 * - TimeField
 *
 * @see https://github.com/harness-software/wp-graphql-gravity-forms#submit-a-form
 * @author WebDevStudios
 * @param  {object} entryData GF form entry data.
 * @param  {object} fieldData GF form field config.
 * @return {Array}            Formatted GF field values.
 */ function processGfFieldValues(entryData, fieldData) {
    var fieldValues = [];
    var fields = {};
    // Ensure fieldData is valid.
    if (!(fieldData === null || fieldData === void 0 ? void 0 : fieldData.edges) || !fieldData.edges.length) {
        return fieldValues;
    }
    fieldData.edges.forEach(function(field) {
        var ref;
        if (!(field === null || field === void 0 ? void 0 : (ref = field.node) === null || ref === void 0 ? void 0 : ref.id)) {
            return;
        }
        // Add fields config to fields object with ID as key.
        fields[field.node.id] = field.node;
    });
    Object.keys(entryData).forEach(function(fieldName) {
        // Extract first part of field name ("field-<ID>").
        var fieldNamePieces = fieldName.match(/^field-\d+/);
        // Ensure a field ID was found.
        if (!fieldNamePieces || !fieldNamePieces.length) {
            return;
        }
        // Extract field ID from field name.
        var fieldId = parseInt(fieldNamePieces[0].replace("field-", ""), 10);
        // Get field config by ID.
        var field = fields === null || fields === void 0 ? void 0 : fields[fieldId];
        // Ensure field ID exists in field config.
        if (!field) {
            return;
        }
        var fieldValue = {
            id: fieldId
        };
        // Skip if empty/undefined value.
        if (!entryData[fieldName]) {
            return;
        }
        switch(field === null || field === void 0 ? void 0 : field.__typename){
            case "CheckboxField":
                fieldValue.checkboxValues = [];
                if (!entryData[fieldName].length) {
                    return;
                }
                // Determine checkbox input IDs from index in field config choices array.
                field.checkboxChoices.forEach(function(choice, index) {
                    if (!entryData[fieldName].includes(choice.value)) {
                        return;
                    }
                    fieldValue.checkboxValues.push({
                        inputId: parseFloat("".concat(fieldId, ".").concat(index + 1)),
                        value: choice.value
                    });
                });
                break;
            case "EmailField":
                // TODO: As of WP GraphQL Gravity Forms v.0.4.1, this is accurate, but it appears it may be changing to a nested version in the next release: fieldValue.emailValues = { value, confirmationValue }.
                fieldValue.emailValues = {
                    value: entryData[fieldName]
                };
                break;
            case "FileUploadField":
                fieldValue.fileUploadValues = entryData[fieldName];
                break;
            default:
                fieldValue.value = entryData[fieldName];
                break;
        }
        fieldValues.push(fieldValue);
    });
    return fieldValues;
}

;// CONCATENATED MODULE: ./functions/next-api/wordpress/gravityForms/processGfFormSubmission.js





/**
 * Process GF form submission via Next API.
 *
 * @author WebDevStudios
 * @param  {number} formId    GF form ID.
 * @param  {object} entryData GF form entry data.
 * @param  {object} fieldData GF form field config.
 * @return {object}           Entry ID and confirmation message or error object.
 */ function processGfFormSubmission(formId, entryData, fieldData) {
    return _processGfFormSubmission.apply(this, arguments);
}
function _processGfFormSubmission() {
    _processGfFormSubmission = (0,_async_to_generator/* default */.Z)(function(formId, entryData, fieldData) {
        var fieldValues, apolloClient;
        return (0,tslib_es6.__generator)(this, function(_state) {
            // Check data values.
            if (!formId || !parseInt(formId, 10)) {
                return [
                    2,
                    {
                        error: true,
                        errorMessage: "Form ID is not valid."
                    }
                ];
            }
            if (!entryData) {
                return [
                    2,
                    {
                        error: true,
                        errorMessage: "No form data provided."
                    }
                ];
            }
            fieldValues = processGfFieldValues(entryData, fieldData);
            apolloClient = (0,connector/* initializeNextApiApollo */.nr)();
            return [
                2,
                apolloClient.mutate({
                    mutation: gravityForms_mutationSubmitForm,
                    variables: {
                        formId: formId,
                        fieldValues: fieldValues
                    }
                }).then(function(response) {
                    var _formEntry = response.data.formEntry, entryId = _formEntry.entryId, confirmationMessage = _formEntry.confirmationMessage;
                    if (!entryId) {
                        return {
                            error: true,
                            errorMessage: "An error occurred while attempting to process the form entry."
                        };
                    }
                    return {
                        entryId: entryId,
                        confirmationMessage: confirmationMessage
                    };
                }).catch(function(error) {
                    return {
                        error: true,
                        errorMessage: error.message
                    };
                })
            ];
        });
    });
    return _processGfFormSubmission.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/getGfFieldId.js
/**
 * Create a field ID based on GravityForms provided ID.
 *
 * @author WebDevStudios
 * @param  {number} fieldId GravityForm field ID.
 * @return {string}         A unique string identifer for the field.
 */ function getGfFieldId(fieldId) {
    if (!fieldId || typeof fieldId !== "number") {
        return fieldId;
    }
    return "field-".concat(fieldId);
}

;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/getGfFormDefaults.js


/**
 * Assign default values for GravityForm Checkboxes.
 *
 * @param  {Array} checkboxes Array of checkbox data Objects.
 * @return {Array}            Array of isSelected checkbox values.
 */ function getCheckboxDefaults(checkboxes) {
    var checkboxDefault = [];
    if (!checkboxes.length > 0) {
        return checkboxDefault;
    }
    /**
   * Assign values from isSelected checkboxes.
   */ checkboxes.filter(function(checkbox) {
        return !!(checkbox === null || checkbox === void 0 ? void 0 : checkbox.isSelected);
    }).forEach(function(checkbox) {
        checkboxDefault.push(checkbox.value);
    });
    return checkboxDefault;
}
/**
 * Assign default values for GravityForm Select.
 *
 * @param  {Array}  options Array of select option data Objects.
 * @return {string}         Select option value that is selected.
 */ function getSelectDefaults(options) {
    var selectDefault = "";
    if (!options.length > 0) {
        return selectDefault;
    }
    /**
   * Get first option with isSelected property.
   */ var selectedOption = options.filter(function(option) {
        return !!option.isSelected;
    }).shift();
    if (selectedOption) {
        selectDefault = selectedOption.value;
    }
    return selectDefault;
}
/**
 * Match field type with a default value.
 *
 * @author WebDevStudios
 * @param  {object} fieldData GravityForm field props.
 * @return {any}              Field default value.
 */ function getFieldDefaultByType(fieldData) {
    // Setup field data default
    var defaultValue = "";
    switch(fieldData === null || fieldData === void 0 ? void 0 : fieldData.type){
        case "checkbox":
            defaultValue = getCheckboxDefaults(fieldData === null || fieldData === void 0 ? void 0 : fieldData.checkboxChoices);
            break;
        case "select":
            defaultValue = getSelectDefaults(fieldData === null || fieldData === void 0 ? void 0 : fieldData.selectChoices);
            break;
        default:
            defaultValue = fieldData === null || fieldData === void 0 ? void 0 : fieldData.defaultValue;
    }
    if ((fieldData === null || fieldData === void 0 ? void 0 : fieldData.type) === "HIDDEN" && fieldData.inputName === "Course Name") {
        defaultValue = "tesssss";
    }
    return defaultValue;
}
/**
 * Map field GravityForm ids and defaults to Object.
 *
 * @param  {Array}  fields Array of fields.
 * @return {object}        Default field values.
 */ function getGfFormDefaults(fields) {
    var formDefaults = {};
    if (!fields || !fields.length) {
        return formDefaults;
    }
    fields.forEach(function(field) {
        if (!field.node.id) {
            return;
        }
        Object.assign(formDefaults, (0,_define_property/* default */.Z)({}, getGfFieldId(field.node.id), getFieldDefaultByType(field.node)));
    });
    return formDefaults;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/yupSchema/ArraySchemaFactory.js



var ArraySchemaFactory = /*#__PURE__*/ function() {
    "use strict";
    function ArraySchemaFactory(fieldData) {
        (0,_class_call_check/* default */.Z)(this, ArraySchemaFactory);
        this.fieldData = fieldData;
    }
    (0,_create_class/* default */.Z)(ArraySchemaFactory, [
        {
            key: "schema",
            get: /**
   * Get Yup schema object with validation requirements.
   *
   * Combine multiple schemas into one.
   *
   * @see https://github.com/jquense/yup#mixedconcatschema-schema-schema
   * @return {object} Combined Yup validationSchema Object.
   */ function get() {
                return es/* array */.IX().concat(this.getMinLengthSchema());
            }
        },
        {
            /**
   * Set a minimum length limit for the array.
   *
   * @see https://github.com/jquense/yup#arrayminlimit-number--ref-message-string--function-schema
   * @return {object} Yup validationSchema Object.
   */ key: "getMinLengthSchema",
            value: function getMinLengthSchema() {
                var ref;
                if (!((ref = this.fieldData) === null || ref === void 0 ? void 0 : ref.isRequired)) {
                    return es/* array */.IX();
                }
                return es/* array */.IX().min(1, "Atleast one option must be checked.");
            }
        }
    ]);
    return ArraySchemaFactory;
}();
/**
 * Create Yup Array schema object.
 *
 * @author WebDevStudios
 * @see https://github.com/jquense/yup#array
 * @return {object} Yup validationSchema Object.
 */ 

;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/yupSchema/StringSchemaFactory.js



var StringSchemaFactory = /*#__PURE__*/ function() {
    "use strict";
    function StringSchemaFactory(fieldData) {
        (0,_class_call_check/* default */.Z)(this, StringSchemaFactory);
        this.fieldData = fieldData;
    }
    (0,_create_class/* default */.Z)(StringSchemaFactory, [
        {
            key: "schema",
            get: /**
   * Get Yup schema object with validation requirements.
   *
   * Combine multiple schemas into one.
   *
   * @see https://github.com/jquense/yup#mixedconcatschema-schema-schema
   * @return {object} Combined Yup validationSchema Object.
   */ function get() {
                return es/* string */.Z_().concat(this.getEmailSchema()).concat(this.getMaxLengthSchema()).concat(this.getRequiredSchema()).concat(this.getUrlSchema());
            }
        },
        {
            /**
   * Get Yup required field validaion.
   *
   * @see https://github.com/jquense/yup#stringemailmessage-string--function-schema
   * @return {object} Yup validationSchema Object.
   */ key: "getEmailSchema",
            value: function getEmailSchema() {
                var ref;
                if (((ref = this.fieldData) === null || ref === void 0 ? void 0 : ref.type) !== "email") {
                    return;
                }
                return es/* string */.Z_().email("Must be a valid email.");
            }
        },
        {
            /**
   * Get Yup max line length validation.
   *
   * @see https://github.com/jquense/yup#stringmaxlimit-number--ref-message-string--function-schema
   * @return {object} Yup validationSchema Object.
   */ key: "getMaxLengthSchema",
            value: function getMaxLengthSchema() {
                var ref;
                if (!((ref = this.fieldData) === null || ref === void 0 ? void 0 : ref.maxLength)) {
                    return;
                }
                return es/* string */.Z_().max(this.fieldData.maxLength, "Must be ".concat(this.fieldData.maxLength, " characters or less"));
            }
        },
        {
            /**
   * Get Yup required field validaion.
   *
   * @see https://github.com/jquense/yup#stringrequiredmessage-string--function-schema
   * @return {object} Yup validationSchema Object.
   */ key: "getRequiredSchema",
            value: function getRequiredSchema() {
                var ref;
                if (!((ref = this.fieldData) === null || ref === void 0 ? void 0 : ref.isRequired)) {
                    return;
                }
                return es/* string */.Z_().required("Required!");
            }
        },
        {
            /**
   * Get Yup required field validaion.
   *
   * @see https://github.com/jquense/yup#stringurlmessage-string--function-schema
   * @return {object} Yup validationSchema Object.
   */ key: "getUrlSchema",
            value: function getUrlSchema() {
                var ref;
                if (((ref = this.fieldData) === null || ref === void 0 ? void 0 : ref.type) !== "website") {
                    return;
                }
                return es/* string */.Z_().url('Must be a valid url "https://example.com".');
            }
        }
    ]);
    return StringSchemaFactory;
}();
/**
 * Create Yup string schema object.
 *
 * @author WebDevStudios
 * @see https://github.com/jquense/yup#string
 * @return {object} Yup validationSchema Object.
 */ 

;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/getGfFormValidationSchema.js





/**
 * Match field type with Yup schema object.
 *
 * Match GravityForm field to Yup API property.
 *
 * @author WebDevStudios
 * @see https://github.com/jquense/yup#api
 * @param  {object} fieldData GravityForm field props.
 * @return {object}           Schema validation for field.
 */ function getValidationSchemaByType(fieldData) {
    var schemaGetter = null;
    switch(fieldData === null || fieldData === void 0 ? void 0 : fieldData.type){
        case "checkbox":
            schemaGetter = new ArraySchemaFactory(fieldData).schema;
            break;
        case "email":
            schemaGetter = new StringSchemaFactory(fieldData).schema;
            break;
        case "phone":
            schemaGetter = new StringSchemaFactory(fieldData).schema;
            break;
        case "text":
            schemaGetter = new StringSchemaFactory(fieldData).schema;
            break;
        case "select":
            schemaGetter = new StringSchemaFactory(fieldData).schema;
            break;
        case "website":
            schemaGetter = new StringSchemaFactory(fieldData).schema;
            break;
        default:
            return;
    }
    return schemaGetter;
}
/**
 * Create validation schema Object for a single field.
 *
 * @author WebDevStudios
 * @param  {object} fieldData GravityForm field props.
 * @return {object}           Field validation schema object.
 */ function getGfFieldValidationSchema(fieldData) {
    return (0,_define_property/* default */.Z)({}, getGfFieldId(fieldData.id), getValidationSchemaByType(fieldData));
}
/**
 * Create validation schema Object for GravityForm.
 *
 * @param  {Array}  fields Array of fields.
 * @return {object}        Form validation schema object.
 */ function getGfFormValidationSchema(fields) {
    var formValidationSchema = {};
    if (!fields || !fields.length) {
        return formValidationSchema;
    }
    fields.forEach(function(field) {
        if (!field.node.id) {
            return;
        }
        Object.assign(formValidationSchema, getGfFieldValidationSchema(field === null || field === void 0 ? void 0 : field.node));
    });
    return es/* object */.Ry(formValidationSchema);
}

// EXTERNAL MODULE: ./components/atoms/Inputs/Checkbox/Checkbox.module.scss
var Checkbox_module = __webpack_require__(5297);
var Checkbox_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_module);
;// CONCATENATED MODULE: ./components/atoms/Inputs/Checkbox/Checkbox.js






/**
 * Render Checkbox component.
 *
 * @param  {object}        props           The component attributes as props.
 * @param  {string}        props.className Input className.
 * @param  {string|number} props.id        Input id.
 * @param  {string}        props.label     Input label.
 * @param  {string}        props.name      Input name.
 * @param  {string}        props.value     Input value.
 * @return {Element}                       The Checkbox component.
 */ function Checkbox(param) {
    var className = param.className, id = param.id, label = param.label, name = param.name, isRequired = param.isRequired, setFieldValue = param.setFieldValue;
    var ref = (0,react.useState)(false), isChecked = ref[0], setIsChecked = ref[1];
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(className, (Checkbox_module_default()).checkbox, error ? (Checkbox_module_default()).isError : ""),
        children: label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    id: id,
                    name: name,
                    type: "checkbox",
                    onChange: function() {
                        setIsChecked(!isChecked);
                        setFieldValue("".concat(id, "_filedata"), "".concat(isChecked));
                        isChecked ? setError(false) : null;
                    },
                    checked: isChecked,
                    required: isRequired,
                    onInvalid: function() {
                        return setError(true);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Checkbox_module_default()).label,
                    dangerouslySetInnerHTML: {
                        __html: label
                    }
                })
            ]
        })
    });
}
Checkbox.propTypes = {
    className: (prop_types_default()).string,
    id: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]).isRequired,
    label: (prop_types_default()).string,
    name: (prop_types_default()).string,
    value: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/atoms/Inputs/Checkbox/index.js


;// CONCATENATED MODULE: ./components/atoms/Inputs/CheckboxGroup/CheckboxGroup.js




/**
 * Render CheckboxGroup component.
 *
 * @param  {object}        props             The component attributes as props.
 * @param  {Array}         props.checkboxes  Array of checkbox data objects.
 * @param  {string}        props.className   CheckboxGroup wrapper className.
 * @param  {string|number} props.id          CheckboxGroup id.
 * @param  {string}        props.label       CheckboxGroup input label.
 * @param  {string}        props.description CheckboxGroup input name.
 * @param  {boolean}       props.isRequired  If input is required.
 * @return {Element}                         The CheckboxGroup component.
 */ function CheckboxGroup(param) {
    var checkboxes = param.checkboxes, className = param.className, description = param.description, groupId = param.id, label = param.label, isRequired = param.isRequired;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "aria-labelledby": groupId,
        className: className,
        id: groupId,
        role: "group",
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: groupId,
                required: isRequired,
                children: label
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            !!checkboxes.length > 0 && checkboxes.map(function(checkbox) {
                var id = checkbox.id, label = checkbox.label, value = checkbox.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                    id: id,
                    label: label,
                    name: groupId,
                    value: value
                }, "".concat(groupId, "-").concat(id));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                name: groupId
            })
        ]
    });
}
CheckboxGroup.propTypes = {
    checkboxes: prop_types_default().arrayOf((prop_types_default()).object).isRequired,
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).string.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    validation: (prop_types_default()).func
};
CheckboxGroup.defaultProps = {
    isRequired: false
};

;// CONCATENATED MODULE: ./components/atoms/Inputs/CheckboxGroup/index.js


// EXTERNAL MODULE: ./components/atoms/Inputs/InputError/InputError.module.scss
var InputError_module = __webpack_require__(33638);
var InputError_module_default = /*#__PURE__*/__webpack_require__.n(InputError_module);
;// CONCATENATED MODULE: ./components/atoms/Inputs/InputError/InputError.js



/**
 * Render the InputError component.
 *
 * @param  {object}        props      The component attributes as props.
 * @param  {string|number} props.name Input id.
 * @return {Element}                  The InputError component.
 */ function InputError(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (InputError_module_default()).inputError,
        children: name
    });
}
InputError.propTypes = {
    name: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ])
};

;// CONCATENATED MODULE: ./components/atoms/Inputs/InputError/index.js


// EXTERNAL MODULE: ./components/atoms/Inputs/Select/Select.module.scss
var Select_module = __webpack_require__(92558);
var Select_module_default = /*#__PURE__*/__webpack_require__.n(Select_module);
;// CONCATENATED MODULE: ./components/atoms/Inputs/Select/Select.js







/**
 * Render the Select component.
 *
 * @author WebDevStudios
 * @param  {object}  props             The component attributes as props.
 * @param  {string}  props.className   Select wrapper className.
 * @param  {string}  props.description Select description.
 * @param  {string}  props.label       Select input label.
 * @param  {string}  props.id          Select input id.
 * @param  {boolean} props.isRequired  If input is required.
 * @param  {Array}   props.options     Array of input options objects.
 * @return {Element}                   The Select component.
 */ function Select(param) {
    var className = param.className, description = param.description, id = param.id, isRequired = param.isRequired, label = param.label, options = param.options, placeholder = param.placeholder, errorMessage = param.errorMessage, setFieldValue = param.setFieldValue;
    var ref = (0,react.useState)(false), showError = ref[0], setShowError = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Select_module_default()).select, className, showError ? (Select_module_default()).isError : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Select_module_default()).container,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        required: isRequired,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Select_module_default()).selectWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Field */.gN, {
                            onInvalid: function() {
                                return setShowError(true);
                            },
                            as: "select",
                            id: id,
                            name: id,
                            required: isRequired,
                            onChange: function(e) {
                                e.target.value === "" ? setShowError(true) : setShowError(false);
                                setFieldValue("".concat(id, "_filedata"), e.target.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "",
                                    disabled: isRequired,
                                    selected: true,
                                    children: placeholder
                                }),
                                !!(options === null || options === void 0 ? void 0 : options.length) > 0 && options.map(function(option, key) {
                                    var text = option.text, value = option.value;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: value,
                                        children: text
                                    }, key);
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: description
                                })
                            ]
                        })
                    })
                ]
            }),
            showError && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError, {
                name: errorMessage
            })
        ]
    });
}
Select.propTypes = {
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).string.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    options: prop_types_default().arrayOf((prop_types_default()).object)
};
Select.defaultProps = {
    isRequired: false
};

;// CONCATENATED MODULE: ./components/atoms/Inputs/Select/index.js


// EXTERNAL MODULE: ./components/atoms/Inputs/Text/Text.module.scss
var Text_module = __webpack_require__(4477);
var Text_module_default = /*#__PURE__*/__webpack_require__.n(Text_module);
;// CONCATENATED MODULE: ./components/atoms/Inputs/Text/Text.js







/**
 * Render the Text component.
 *
 * @author WebDevStudios
 * @param  {object}  props             The component attributes as props.
 * @param  {string}  props.className   Text wrapper className.
 * @param  {string}  props.description Text description.
 * @param  {string}  props.id          Text input id.
 * @param  {string}  props.label       Text input label.
 * @param  {boolean} props.isRequired  If input is required.
 * @param  {string}  props.type        Text input type.
 * @return {Element}                   The Text component.
 */ function Text(param) {
    var className = param.className, description = param.description, id = param.id, isRequired = param.isRequired, label = param.label, type = param.type, placeholder = param.placeholder, errorMessage = param.errorMessage, setFieldValue = param.setFieldValue;
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(false), showError = ref1[0], setShowError = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Text_module_default()).text, className, type === "HIDDEN" ? (Text_module_default()).isHidden : "", showError ? (Text_module_default()).isError : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Text_module_default()).textContainer,
                children: [
                    label && type !== "HIDDEN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: id,
                        required: isRequired,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        "aria-required": isRequired,
                        id: id,
                        name: id,
                        required: isRequired,
                        type: type,
                        placeholder: placeholder,
                        onInvalid: function() {
                            return setShowError(true);
                        },
                        onChange: function(e) {
                            setValue(e.target.value);
                            setFieldValue("".concat(id, "_filedata"), e.target.value);
                            e.target.value === "" ? setShowError(true) : setShowError(false);
                            type === "EMAIL" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(e.target.value) ? setShowError(true) : setShowError(false);
                        },
                        value: value
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            showError && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError, {
                name: errorMessage
            })
        ]
    });
}
Text.propTypes = {
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).string.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired
};
Text.defaultProps = {
    isRequired: false
};

;// CONCATENATED MODULE: ./components/atoms/Inputs/Text/index.js


;// CONCATENATED MODULE: ./components/atoms/Inputs/index.js





;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/getHiddenClassName.js
/**
 * Determine hidden className.
 *
 * @author WebDevStudios
 * @param  {string} visibility setting of GravityForm field.
 * @return {string}            Classname selector based on visibility.
 */ function getGfHiddenClassName(visibility) {
    if (!visibility || typeof visibility !== "string") {
        return "";
    }
    var className = "";
    switch(visibility){
        case "hidden":
            className = "gfFieldHidden";
            break;
        case "administrative":
            className = "gfFieldHiddenAdmin";
            break;
        default:
            break;
    }
    return className;
}

;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Checkbox.js






/**
 * Merge GravityForm checkbox field data into single Array.
 *
 * @param  {Array} checkboxChoices Array of checkbox field input data.
 * @param  {Array} inputs          Array of checkbox field input data.
 * @return {Array}                 Checkbox data Array with combined Objects.
 */ function getMergedCheckboxes(checkboxChoices, inputs) {
    var checkboxes = [];
    checkboxChoices.forEach(function(checkbox, index) {
        checkboxes.push((0,_object_spread/* default */.Z)({}, checkbox, inputs[index]));
    });
    return checkboxes;
}
/**
 * Render GravityForms Checkbox field component.
 *
 * @param  {object}        props                 GravityForm Checkbox field as props.
 * @param  {Array}         props.checkboxChoices Array of checkbox field input data.
 * @param  {string}        props.className       GravityForm field wrapper class.
 * @param  {string}        props.description     GravityForm field description.
 * @param  {Array}         props.inputs          Array of checkbox field input data.
 * @param  {string|number} props.id              GravityForm field id.
 * @param  {boolean}       props.isRequired      If input is required.
 * @param  {string}        props.label           GravityForm field label.
 * @param  {boolean}       props.visibility      GravityForm field visibility.
 * @return {Element}                             The Checkbox component.
 */ function Checkbox_Checkbox(param) {
    var className = param.className, checkboxChoices = param.checkboxChoices, description = param.description, id = param.id, isRequired = param.isRequired, inputs = param.inputs, label = param.label, visibility = param.visibility;
    var fieldId = getGfFieldId(id);
    var isHiddenClass = getGfHiddenClassName(visibility);
    var checkboxes = getMergedCheckboxes(checkboxChoices, inputs);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxGroup, {
        className: classnames_default()(className, isHiddenClass) || null,
        checkboxes: checkboxes,
        description: description,
        id: fieldId,
        label: label,
        isRequired: isRequired
    });
}
Checkbox_Checkbox.propTypes = {
    checkboxChoices: prop_types_default().arrayOf((prop_types_default()).object),
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).number.isRequired,
    inputs: prop_types_default().arrayOf((prop_types_default()).object),
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    visibility: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/molecules/GravityForm/Fields/Consent.module.scss
var Consent_module = __webpack_require__(51518);
var Consent_module_default = /*#__PURE__*/__webpack_require__.n(Consent_module);
;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Consent.js





/**
 * Render GravityForms Textarea field component.
 *
 * @param  {object}        props             GravityForm Select field as props.
 * @param  {string}        props.className   GravityForm field wrapper class.
 * @param  {string}        props.description GravityForm field description.
 * @param  {string|number} props.id          GravityForm field id.
 * @param  {boolean}       props.isRequired  GravityForm field is required.
 * @param  {string}        props.label       GravityForm field label.
 * @param  {boolean}       props.visibility  GravityForm visibility option.
 * @return {Element}                         The File component.
 */ function Consent(param) {
    var className = param.className, description = param.description, id = param.id, isRequired = param.isRequired, visibility = param.visibility, setFieldValue = param.setFieldValue, checkboxLabel = param.checkboxLabel;
    var fieldId = getGfFieldId(id);
    var isHiddenClass = getGfHiddenClassName(visibility);
    var thisClassName = classnames_default()(className, isHiddenClass);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(thisClassName, (Consent_module_default()).consent),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
            className: classnames_default()(className, isHiddenClass) || null,
            description: description,
            id: fieldId,
            label: checkboxLabel,
            isRequired: isRequired,
            setFieldValue: setFieldValue
        })
    });
}

;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Fields.js






/**
 * Render the Fields component.
 *
 * @author WebDevStudios
 * @param  {object}  props             The component attributes as props.
 * @param  {Array}   props.fields      GravityForm fields data.
 * @param  {object}  props.formikProps Props available to Formik components.
 * @return {Element}                   The Fields component.
 */ function Fields(param) {
    var fields = param.fields, formikProps = param.formikProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: fields.length > 0 && fields.map(function(field) {
            var _node = field.node, id = _node.id, type = _node.type;
            var fieldToRender = null;
            switch(type){
                case "checkbox":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Checkbox_Checkbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id
                    }));
                    break;
                case "EMAIL":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        setFieldValue: formikProps.setFieldValue
                    }, field.node), {
                        key: id
                    }));
                    break;
                case "PHONE":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        setFieldValue: formikProps.setFieldValue
                    }, field.node), {
                        key: id
                    }));
                    break;
                case "SELECT":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Select_Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        setFieldValue: formikProps.setFieldValue
                    }, field.node), {
                        key: id
                    }));
                    break;
                case "HTML":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Select_Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id
                    }));
                    break;
                case "SECTION":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id
                    }));
                    break;
                case "DATE":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id
                    }));
                    break;
                case "TEXT":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id,
                        setFieldValue: formikProps.setFieldValue
                    }));
                    break;
                case "HIDDEN":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id
                    }));
                    break;
                case "website":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id
                    }));
                    break;
                case "TEXTAREA":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(TextArea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id,
                        setFieldValue: formikProps.setFieldValue
                    }));
                    break;
                case "CONSENT":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(Consent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        key: id,
                        setFieldValue: formikProps.setFieldValue
                    }));
                    break;
                case "FILEUPLOAD":
                    fieldToRender = /*#__PURE__*/ (0,react.createElement)(File, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.node), {
                        setFieldValue: formikProps.setFieldValue,
                        key: id,
                        values: formikProps.values
                    }));
                    break;
                default:
                    fieldToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                        children: '"'.concat(type, '" GravityForm field is unsupported.')
                    }, id);
            }
            return fieldToRender;
        })
    });
}
Fields.propTypes = {
    fields: (prop_types_default()).array,
    setFormValidation: (prop_types_default()).func,
    formikProps: (prop_types_default()).object
};
Fields.defaultProps = {
    fields: []
};

// EXTERNAL MODULE: ./components/molecules/GravityForm/Fields/File.module.scss
var File_module = __webpack_require__(20297);
var File_module_default = /*#__PURE__*/__webpack_require__.n(File_module);
// EXTERNAL MODULE: ./components/atoms/Icon/index.ts
var Icon = __webpack_require__(16372);
;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/File.js










/**
 * Render GravityForms File field component.
 *
 * @param  {object}        props               GravityForm Select field as props.
 * @param  {string}        props.className     GravityForm field wrapper class.
 * @param  {string}        props.description   GravityForm field description.
 * @param  {string|number} props.id            GravityForm field id.
 * @param  {boolean}       props.isRequired    GravityForm field is required.
 * @param  {string}        props.label         GravityForm field label.
 * @param  {boolean}       props.visibility    GravityForm visibility option.
 * @param  {Function}      props.setFieldValue Formik function to set state.
 * @return {Element}                           The File component.
 */ function File(param) {
    var className = param.className, description = param.description, id = param.id, isRequired = param.isRequired, label = param.label, visibility = param.visibility, setFieldValue = param.setFieldValue, conditionalLogic = param.conditionalLogic, values = param.values;
    var fieldId = getGfFieldId(id);
    var thisClassName = classnames_default()(className);
    var ref = (0,react.useState)(""), fileName = ref[0], setFileName = ref[1];
    var ref1 = (0,react.useState)(""), showError = ref1[0], setShowError = ref1[1];
    var ref2 = (0,react.useState)(false), removeHidden = ref2[0], setRemoveHidden = ref2[1];
    (0,react.useEffect)(function() {
        if (conditionalLogic && conditionalLogic.rules.length > 0) {
            var fieldValue = values["field-".concat(conditionalLogic.rules[0].fieldId, "_filedata")];
            setRemoveHidden(fieldValue !== conditionalLogic.rules[0].value);
        }
    }, [
        conditionalLogic,
        values
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Text_module_default()).text, showError ? (Text_module_default()).isError : "", thisClassName, visibility === "HIDDEN" && !removeHidden ? (File_module_default()).isHidden : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (File_module_default()).container,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: id,
                        required: isRequired,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (File_module_default()).fileWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((File_module_default()).filePlaceholder, showError ? (File_module_default()).hasError : ""),
                                children: [
                                    fileName.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        icon: "plusFile",
                                        size: "24",
                                        sizeViewbox: "24",
                                        title: "plus file"
                                    }),
                                    fileName.length > 0 ? fileName : "Datei"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                "aria-required": isRequired,
                                id: fieldId,
                                name: fieldId,
                                required: isRequired,
                                className: (File_module_default()).file,
                                type: "file",
                                accept: "application/pdf",
                                onInvalid: function() {
                                    return setShowError(true);
                                },
                                onChange: function(e) {
                                    setFileName(e.currentTarget.files[0].name);
                                    setShowError(false);
                                    // Save to _filedata here so we don't corrupt state.
                                    setFieldValue("".concat(fieldId, "_filedata"), e.currentTarget.files[0]);
                                }
                            })
                        ]
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            showError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError, {
                name: "Unterst\xfctztes Dateiformat: PDF"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (File_module_default()).showLabel,
                children: "Unterst\xfctztes Dateiformat: PDF"
            })
        ]
    });
}
File.propTypes = {
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).number.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    selectChoices: prop_types_default().arrayOf((prop_types_default()).object),
    visibility: (prop_types_default()).string,
    setFieldValue: (prop_types_default()).func
};

// EXTERNAL MODULE: ./components/molecules/GravityForm/Fields/Section.module.scss
var Section_module = __webpack_require__(70829);
var Section_module_default = /*#__PURE__*/__webpack_require__.n(Section_module);
;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Section.js




function Section(param) {
    var id = param.id, label = param.label, description = param.description, cssClass = param.cssClass;
    var fieldId = getGfFieldId(id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: fieldId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).label,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Section_module_default()).description, cssClass),
                children: description
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/WordPressProvider.js
var WordPressProvider = __webpack_require__(71309);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./functions/dateFormat.js

var dateFormat = function(stringDate) {
    var date = new Date(stringDate);
    var yyyy = date.getFullYear();
    var mm = date.getMonth() + 1 // Months start at 0!
    ;
    var dd = date.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    return dd + "." + mm + "." + yyyy;
};
var changeWordpressDateFormat = function(stringDate) {
    if (!stringDate) return;
    var ref = (0,_sliced_to_array/* default */.Z)(stringDate.split("/"), 3), day = ref[0], month = ref[1], year = ref[2];
    return new Date(year, month - 1, day);
};

;// CONCATENATED MODULE: ./functions/formatCourses.js


var formatCourse = function(course) {
    var ref;
    var tempCourse = (0,_object_spread/* default */.Z)({}, course);
    if (((ref = tempCourse.CourseFields.variations) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        var ref1;
        var today = new Date();
        var sortDates = (ref1 = tempCourse.CourseFields.variations) === null || ref1 === void 0 ? void 0 : ref1.slice().sort(function(a, b) {
            return changeWordpressDateFormat(a.startDate) - changeWordpressDateFormat(b.startDate);
        });
        var afterDates = sortDates === null || sortDates === void 0 ? void 0 : sortDates.filter(function(d) {
            return changeWordpressDateFormat(d.startDate) - today > 0;
        });
        tempCourse.variations = [];
        tempCourse.CourseFields = (0,_object_spread/* default */.Z)({
            nextCourse: null
        }, tempCourse.CourseFields);
        if ((afterDates === null || afterDates === void 0 ? void 0 : afterDates.length) > 0) {
            tempCourse.CourseFields.nextCourse = dateFormat(changeWordpressDateFormat(afterDates[0].startDate)) + " - " + dateFormat(changeWordpressDateFormat(afterDates[0].endDate));
            tempCourse.CourseFields.language = afterDates[0].language;
            afterDates.forEach(function(variation) {
                var CourseFields = {};
                CourseFields.diploma = tempCourse.CourseFields.diploma;
                CourseFields.language = variation.language;
                CourseFields.nextCourse = dateFormat(changeWordpressDateFormat(variation.startDate)) + " - " + dateFormat(changeWordpressDateFormat(variation.endDate));
                tempCourse.variations.push({
                    CourseFields: CourseFields,
                    courseCategorys: course.courseCategorys,
                    title: course.title
                });
            });
        }
    }
    return tempCourse;
};
var formatCourses = function(courses) {
    return courses.map(function(course) {
        return formatCourse(course);
    });
};
var labelMapping = {
    accreditation: "Akkreditierung",
    applicationDeadline: "Bewerbungsfrist",
    classSize: "Kursgr\xf6\xdfe",
    diploma: "Abschluss",
    duration: "Dauer",
    format: "Format",
    language: "Sprache",
    nextCourse: "N\xe4chster Kurs",
    participationFee: "Teilnahmegeb\xfchr",
    partnerInstitution: "Partnereinrichtung",
    targetGroup: "Zielgruppe"
};

;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Select.js







/**
 * Render GravityForms Select field component.
 *
 * @param  {object}        props               GravityForm Select field as props.
 * @param  {string}        props.className     GravityForm field wrapper class.
 * @param  {string}        props.description   GravityForm field description.
 * @param  {string|number} props.id            GravityForm field id.
 * @param  {boolean}       props.isRequired    GravityForm field is required.
 * @param  {string}        props.label         GravityForm field label.
 * @param  {Array}         props.selectChoices GravityForm field selection options.
 * @param  {boolean}       props.visibility    GravityForm field visibility.
 * @return {Element}                           The Select component.
 */ function Select_Select(param) {
    var className = param.className, description = param.description, id = param.id, isRequired = param.isRequired, label = param.label, selectChoices = param.selectChoices, visibility = param.visibility, placeholder = param.placeholder, errorMessage = param.errorMessage, setFieldValue = param.setFieldValue, adminLabel = param.adminLabel, cssClass = param.cssClass;
    var fieldId = getGfFieldId(id);
    var isHiddenClass = getGfHiddenClassName(visibility);
    var post = (0,WordPressProvider/* useWordPressContext */.Kp)().post;
    var customOptions = [];
    if (adminLabel === "Course-Dates") {
        var formattedPost = formatCourse(post);
        customOptions = formattedPost.variations.map(function(variation) {
            return {
                text: variation.CourseFields.nextCourse,
                value: variation.CourseFields.nextCourse,
                __typename: "SelectFieldChoice",
                isSelected: false
            };
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
        className: classnames_default()(className, cssClass, isHiddenClass) || null,
        description: description,
        id: fieldId,
        isRequired: isRequired,
        label: label,
        options: customOptions.length > 0 ? customOptions : selectChoices,
        placeholder: placeholder,
        errorMessage: errorMessage,
        setFieldValue: setFieldValue
    });
}
Select_Select.propTypes = {
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).number.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    selectChoices: prop_types_default().arrayOf((prop_types_default()).object),
    visibility: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/molecules/GravityForm/Fields/Text.module.scss
var Fields_Text_module = __webpack_require__(96144);
var Fields_Text_module_default = /*#__PURE__*/__webpack_require__.n(Fields_Text_module);
;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Text.js







/**
 * Render the GravityForm Text component.
 *
 * @author WebDevStudios
 * @param  {object}  props                     GravityForm field props.
 * @param  {string}  props.className           Classname string.
 * @param  {string}  props.description         GravityForm field description.
 * @param  {boolean} props.enablePasswordInput GravityForm password enabled option.
 * @param  {string}  props.errorMessage        GravityForm error message option.
 * @param  {number}  props.id                  GravityForm unique field id.
 * @param  {boolean} props.isRequired          GravityForm isRequired field.
 * @param  {string}  props.label               GravityForm field label.
 * @param  {string}  props.type                GravityForm field type.
 * @param  {boolean} props.visibility          GravityForm visibility option.
 * @return {Element}                           The Text component.
 */ function Text_Text(param) {
    var className = param.className, description = param.description, enablePasswordInput = param.enablePasswordInput, errorMessage = param.errorMessage, id = param.id, isRequired = param.isRequired, label = param.label, type = param.type, visibility = param.visibility, placeholder = param.placeholder, setFieldValue = param.setFieldValue, cssClass = param.cssClass;
    var modifyFieldType = /**
   * Convert type to an HTML input type.
   *
   * @param  {string} type GravityForm field type.
   * @return {string}      HTML input type.
   */ function modifyFieldType(type) {
        var inputType = type;
        if (enablePasswordInput && "password") {
            inputType = "password";
        }
        if (type === "phone") {
            inputType = "tel";
        }
        if (type === "website") {
            inputType = "url";
        }
        return inputType;
    };
    var fieldId = getGfFieldId(id);
    var isHiddenClass = getGfHiddenClassName(visibility);
    var inputType = modifyFieldType(type);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Fields_Text_module_default()).textWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                className: classnames_default()(className, cssClass, isHiddenClass) || null,
                description: description,
                errorMessage: errorMessage,
                placeholder: placeholder,
                id: fieldId,
                isRequired: isRequired,
                label: label,
                type: inputType,
                setFieldValue: setFieldValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                tag: "button",
                type: "white",
                iconSize: 40,
                text: ""
            })
        ]
    });
}
Text_Text.propTypes = {
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    enablePasswordInput: (prop_types_default()).bool,
    errorMessage: (prop_types_default()).string,
    id: (prop_types_default()).number.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    visibility: (prop_types_default()).string
};
Text_Text.defaultProps = {
    enablePasswordInput: false,
    isRequired: false
};

;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/Textarea.js








/**
 * Render GravityForms Textarea field component.
 *
 * @param  {object}        props             GravityForm Select field as props.
 * @param  {string}        props.className   GravityForm field wrapper class.
 * @param  {string}        props.description GravityForm field description.
 * @param  {string|number} props.id          GravityForm field id.
 * @param  {boolean}       props.isRequired  GravityForm field is required.
 * @param  {string}        props.label       GravityForm field label.
 * @param  {boolean}       props.visibility  GravityForm visibility option.
 * @return {Element}                         The File component.
 */ function TextArea(param) {
    var className = param.className, description = param.description, id = param.id, isRequired = param.isRequired, label = param.label, visibility = param.visibility, errorMessage = param.errorMessage, setFieldValue = param.setFieldValue, placeholder = param.placeholder;
    var fieldId = getGfFieldId(id);
    var isHiddenClass = getGfHiddenClassName(visibility);
    var thisClassName = classnames_default()(className, isHiddenClass);
    var ref = (0,react.useState)(false), showError = ref[0], setShowError = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Text_module_default()).text, (Text_module_default()).textArea, thisClassName, showError ? (Text_module_default()).isError : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Text_module_default()).textContainer,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: id,
                        required: isRequired,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        "aria-required": isRequired,
                        id: fieldId,
                        name: fieldId,
                        required: isRequired,
                        placeholder: placeholder,
                        as: "textarea",
                        onInvalid: function() {
                            return setShowError(true);
                        },
                        onChange: function(e) {
                            setValue(e.target.value);
                            setFieldValue("".concat(fieldId, "_filedata"), e.target.value);
                            e.target.value === "" ? setShowError(true) : setShowError(false);
                        },
                        value: value
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            showError && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError, {
                name: errorMessage
            })
        ]
    });
}
TextArea.propTypes = {
    className: (prop_types_default()).string,
    description: (prop_types_default()).string,
    id: (prop_types_default()).number.isRequired,
    isRequired: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    selectChoices: prop_types_default().arrayOf((prop_types_default()).object),
    visibility: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/molecules/GravityForm/Fields/index.js









// EXTERNAL MODULE: ./components/molecules/GravityForm/GravityForm.module.scss
var GravityForm_module = __webpack_require__(57278);
var GravityForm_module_default = /*#__PURE__*/__webpack_require__.n(GravityForm_module);
;// CONCATENATED MODULE: ./components/molecules/GravityForm/GravityForm.js











/**
 * Render the GravityForm component.
 *
 * @param  {object}  props                      The GravityForm block attributes as props.
 * @param  {object}  props.formData             GravityForm form data.
 * @param  {string}  props.formData.cssClass    GravityForm form classname.
 * @param  {string}  props.formData.description GravityForm form description.
 * @param  {object}  props.formData.formFields  GravityForm form fields.
 * @param  {number}  props.formData.formId      GravityForm form id.
 * @param  {string}  props.formData.title       GravityForm form title.
 * @return {Element}                            The GravityForm component.
 */ function GravityForm(param) {
    var formData = param.formData;
    var cssClass = formData.cssClass, formFields = formData.formFields, formId = formData.formId;
    // Setup form defaults and validation based on GravityForm field data.
    var fieldData = formFields === null || formFields === void 0 ? void 0 : formFields.edges;
    var formValidationSchema = getGfFormValidationSchema(fieldData);
    var fieldDefaults = getGfFormDefaults(fieldData);
    var ref = (0,react.useState)(false), formFeedback = ref[0], setFeedback = ref[1];
    function handleFormSubmission(values) {
        return _handleFormSubmission.apply(this, arguments);
    }
    function _handleFormSubmission() {
        _handleFormSubmission = /**
   * Handle form submission.
   *
   * @author WebDevStudios
   * @param {object} values Form values.
   */ (0,_async_to_generator/* default */.Z)(function(values) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            processGfFormSubmission(formId, values, formFields)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response === null || response === void 0 ? void 0 : response.error) {
                            setFeedback(response.errorMessage);
                            return [
                                2
                            ];
                        }
                        setFeedback(response.confirmationMessage);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFormSubmission.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
            className: cssClass,
            formDefaults: fieldDefaults,
            id: formId && "gform-".concat(formId),
            validationSchema: formValidationSchema,
            onSubmit: handleFormSubmission,
            children: function(formikProps) {
                return formFeedback ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (GravityForm_module_default()).feedback,
                        dangerouslySetInnerHTML: {
                            __html: formFeedback
                        }
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: fieldData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields, {
                        fields: fieldData,
                        formikProps: formikProps
                    })
                });
            }
        })
    });
}
GravityForm.propTypes = {
    formData: prop_types_default().shape({
        cssClass: (prop_types_default()).string,
        description: (prop_types_default()).string,
        formFields: (prop_types_default()).object,
        formId: (prop_types_default()).number,
        title: (prop_types_default()).string
    })
};

;// CONCATENATED MODULE: ./components/molecules/GravityForm/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockGravityForm/BlockGravityForm.js




/**
 * GravityForm block.
 *
 * @author WebDevStudios
 * @param  {object}  attributes Component attributes.
 * @return {Element}            The GravityForm component.
 */ function BlockGravityForm(attributes) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GravityForm, (0,_object_spread/* default */.Z)({}, attributes));
}
BlockGravityForm.propTypes = {
    attributes: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockGravityForm/index.js


// EXTERNAL MODULE: ./components/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(17001);
;// CONCATENATED MODULE: ./components/blocks/core/BlockHeadings/BlockHeadings.js






/**
 * Headings Block
 *
 * The core Headings block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component props.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.backgroundColorHex The background color hex value.
 * @param  {string}  props.className          Optional classnames.
 * @param  {string}  props.content            The content of the block.
 * @param  {number}  props.level              The heading level.
 * @param  {object}  props.style              The style attributes.
 * @param  {string}  props.textAlign          Optional alignment style.
 * @param  {string}  props.textColorHex       The text color hex value.
 * @return {Element}                          The RichText component.
 */ function BlockHeadings(param) {
    var anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, className = param.className, content = param.content, level = param.level, style = param.style, textAlign = param.textAlign, textColorHex = param.textColorHex;
    var headingStyle = getBlockStyles({
        backgroundColorHex: backgroundColorHex,
        textColorHex: textColorHex,
        style: style
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        className: classnames_default()(className, textAlign === "center" ? "text-center" : null, !textAlign || textAlign === "left" ? "text-left" : null, textAlign === "right" ? "text-right" : null),
        id: anchor,
        style: headingStyle,
        tag: "h" + level,
        children: content
    });
}
BlockHeadings.propTypes = {
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    className: (prop_types_default()).string,
    content: (prop_types_default()).string,
    level: (prop_types_default()).number,
    style: (prop_types_default()).object,
    textAlign: (prop_types_default()).string,
    textColorHex: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockHeadings/index.js


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts
var Container = __webpack_require__(691);
// EXTERNAL MODULE: ./components/atoms/Image/Image.module.css
var Image_module = __webpack_require__(71858);
var Image_module_default = /*#__PURE__*/__webpack_require__.n(Image_module);
;// CONCATENATED MODULE: ./components/atoms/Image/Image.js









/**
 * Render the Display Image component.
 *
 * @author WebDevStudios
 * @param  {object}  props               The component properties.
 * @param  {string}  props.alt           The image alt attribute.
 * @param  {string}  props.anchor        The image anchor.
 * @param  {string}  props.caption       The image caption.
 * @param  {string}  props.className     The image class name.
 * @param  {string}  props.href          A link wrapping the image.
 * @param  {number}  props.id            The image id.
 * @param  {object}  props.imageMeta     The image meta.
 * @param  {string}  props.linkClass     The image link class name.
 * @param  {string}  props.linkTarget    The image link target.
 * @param  {boolean} props.nextImageFill Whether next/image should be set to fill or have height/width defined.
 * @param  {string}  props.rel           The relationship of the linked URL.
 * @param  {string}  props.url           The image src attribute.
 * @return {Element}                     The DisplayImage component.
 */ function DisplayImage(props) {
    var NextImage = /**
   * Next.js <Image /> component.
   *
   * @see https://nextjs.org/docs/basic-features/image-optimization
   * @return {Element} The next/image component.
   */ function NextImage() {
        var imageProps = {
            alt: props === null || props === void 0 ? void 0 : props.alt,
            id: props === null || props === void 0 ? void 0 : props.anchor,
            src: source
        };
        // Add extra props depending on whether image needs to be set to "fill".
        if (props === null || props === void 0 ? void 0 : props.nextImageFill) {
            imageProps.layout = "fill";
        } else {
            imageProps.height = imageSize === null || imageSize === void 0 ? void 0 : imageSize.height;
            imageProps.width = imageSize === null || imageSize === void 0 ? void 0 : imageSize.width;
        }
        return(// eslint-disable-next-line
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            size: "large",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageProps), {
                className: classnames_default()((props === null || props === void 0 ? void 0 : props.nextImageFill) ? (Image_module_default()).imageFill : null)
            }))
        }));
    };
    var HtmlImage = /**
   * HTML image component.
   *
   * @return {Element} A plain ol' HTML <img> tag.
   */ function HtmlImage() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: props === null || props === void 0 ? void 0 : props.alt,
            className: classnames_default()((Image_module_default()).image, props === null || props === void 0 ? void 0 : props.className),
            height: imageSize === null || imageSize === void 0 ? void 0 : imageSize.height,
            id: props === null || props === void 0 ? void 0 : props.anchor,
            src: props === null || props === void 0 ? void 0 : props.url,
            width: imageSize === null || imageSize === void 0 ? void 0 : imageSize.width
        });
    };
    var ImageLink = /**
   * Image Link component.
   *
   * @param  {object}  props          The component propterties.
   * @param  {Array}   props.children Any children.
   * @return {Element}                The ImageLink component.
   */ function ImageLink(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: props === null || props === void 0 ? void 0 : props.linkClass,
            href: props === null || props === void 0 ? void 0 : props.href,
            rel: props === null || props === void 0 ? void 0 : props.rel,
            target: props === null || props === void 0 ? void 0 : props.linkTarget,
            children: children
        });
    };
    var Caption = /**
   * Image caption component.
   *
   * @return {Element} An image caption.
   */ function Caption() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Image_module_default()).caption,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                tag: "span",
                children: props === null || props === void 0 ? void 0 : props.caption
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5, ref6;
    // Set the image size.
    var imageSize = {
        height: (ref5 = props === null || props === void 0 ? void 0 : (ref = props.imageMeta) === null || ref === void 0 ? void 0 : (ref1 = ref.mediaDetails) === null || ref1 === void 0 ? void 0 : ref1.height) !== null && ref5 !== void 0 ? ref5 : props === null || props === void 0 ? void 0 : props.height,
        width: (ref6 = props === null || props === void 0 ? void 0 : (ref2 = props.imageMeta) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.mediaDetails) === null || ref3 === void 0 ? void 0 : ref3.width) !== null && ref6 !== void 0 ? ref6 : props === null || props === void 0 ? void 0 : props.width
    };
    var ref7;
    // Set the image src.
    var source = (ref7 = props === null || props === void 0 ? void 0 : (ref4 = props.imageMeta) === null || ref4 === void 0 ? void 0 : ref4.mediaItemUrl) !== null && ref7 !== void 0 ? ref7 : props === null || props === void 0 ? void 0 : props.url;
    // No image src? Bail.
    if (!source) {
        return null;
    }
    // Get the src domain from url.
    var sourceDomain = new URL(source);
    // Get all domains registered in next.config.js.
    var domains = "backend.dhzb.org, foundation-backend.byintention.de, dhzb-backend.byintention.de, backend.dhzb-akademie.de";
    // Split domains string into individual domains.
    domains = !domains || !domains.length ? [] : domains.split(", ");
    /**
   * If src domain includes allowed domains, use <Image /> component.
   *
   * @see https://nextjs.org/docs/basic-features/image-optimization#configuration
   */ if (domains.includes(sourceDomain === null || sourceDomain === void 0 ? void 0 : sourceDomain.host)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: props === null || props === void 0 ? void 0 : props.anchor,
            className: classnames_default()((Image_module_default()).image, props === null || props === void 0 ? void 0 : props.className, (props === null || props === void 0 ? void 0 : props.id) ? "image-".concat(props === null || props === void 0 ? void 0 : props.id) : "", (props === null || props === void 0 ? void 0 : props.nextImageFill) ? (Image_module_default()).hasImageFill : null),
            children: [
                (props === null || props === void 0 ? void 0 : props.href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage, {}),
                !!(props === null || props === void 0 ? void 0 : props.caption) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption, {})
            ]
        });
    }
    /**
   * Otherwise, just use HTML <img />.
   */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (props === null || props === void 0 ? void 0 : props.href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlImage, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlImage, {}),
            !!(props === null || props === void 0 ? void 0 : props.caption) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption, {})
        ]
    });
}
DisplayImage.propTypes = {
    alt: prop_types.PropTypes.string,
    anchor: prop_types.PropTypes.string,
    caption: prop_types.PropTypes.string,
    children: prop_types.PropTypes.any,
    className: prop_types.PropTypes.string,
    height: prop_types.PropTypes.string,
    href: prop_types.PropTypes.string,
    id: prop_types.PropTypes.oneOfType([
        prop_types.PropTypes.number,
        prop_types.PropTypes.string
    ]),
    imageMeta: prop_types.PropTypes.shape({
        altText: prop_types.PropTypes.string,
        mediaItemUrl: prop_types.PropTypes.string,
        mediaDetails: prop_types.PropTypes.shape({
            height: prop_types.PropTypes.number,
            sizes: prop_types.PropTypes.array,
            width: prop_types.PropTypes.number
        })
    }),
    linkClass: prop_types.PropTypes.string,
    linkTarget: prop_types.PropTypes.string,
    nextImageFill: prop_types.PropTypes.bool,
    rel: prop_types.PropTypes.string,
    url: prop_types.PropTypes.string,
    width: prop_types.PropTypes.string
};

;// CONCATENATED MODULE: ./components/atoms/Image/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockImage/BlockImage.js




/**
 * Image Block
 *
 * The core Image block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props The component props.
 * @return {Element}       The Block Image component.
 */ function BlockImage(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayImage, (0,_object_spread/* default */.Z)({}, props));
}
BlockImage.propTypes = {
    props: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockImage/index.js


// EXTERNAL MODULE: ./components/molecules/ImageGallery/ImageGallery.module.css
var ImageGallery_module = __webpack_require__(44155);
var ImageGallery_module_default = /*#__PURE__*/__webpack_require__.n(ImageGallery_module);
;// CONCATENATED MODULE: ./components/molecules/ImageGallery/ImageGallery.js







/**
 * Render the ImageGallery component.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component properties.
 * @param  {string}  props.anchor    The anchor/id of the block.
 * @param  {string}  props.caption   The image caption.
 * @param  {string}  props.className The image class.
 * @param  {number}  props.columns   The amount of columns.
 * @param  {Array}   props.images    The array of images.
 * @return {Element}                 The ImageGallery component.
 */ function ImageGallery(param) {
    var anchor = param.anchor, caption = param.caption, columns = param.columns, className = param.className, images = param.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!(images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: anchor || null,
            className: classnames_default()((ImageGallery_module_default()).gallery, className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((ImageGallery_module_default()).wrap, (ImageGallery_module_default())["columns-".concat(columns)]),
                    children: images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ImageGallery_module_default()).imageWrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayImage, {
                                alt: image.alt,
                                id: image.id,
                                url: image.url,
                                nextImageFill: true
                            })
                        }, index);
                    })
                }),
                !!caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageGallery_module_default()).caption,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        tag: "span",
                        children: caption
                    })
                })
            ]
        })
    });
}
ImageGallery.propTypes = {
    anchor: (prop_types_default()).string,
    caption: (prop_types_default()).string,
    columns: (prop_types_default()).number,
    className: (prop_types_default()).string,
    images: prop_types_default().arrayOf(prop_types_default().shape({
        alt: (prop_types_default()).string,
        caption: (prop_types_default()).string,
        fullUrl: (prop_types_default()).string,
        id: (prop_types_default()).string,
        link: (prop_types_default()).string,
        url: (prop_types_default()).string
    }))
};
ImageGallery.defaultProps = {
    columns: 3
};

;// CONCATENATED MODULE: ./components/molecules/ImageGallery/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockImageGallery/BlockImageGallery.js



/**
 * Image Gallery block
 *
 * The core Image Gallery block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component props.
 * @param  {string}  props.anchor    The anchor/id of the block.
 * @param  {string}  props.caption   The image caption.
 * @param  {string}  props.className The image class.
 * @param  {number}  props.columns   The amount of columns.
 * @param  {Array}   props.images    The array of images.
 * @return {Element}                 The ImageGallery component.
 */ function BlockImageGallery(param) {
    var anchor = param.anchor, caption = param.caption, columns = param.columns, className = param.className, images = param.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallery, {
        anchor: anchor,
        caption: caption,
        columns: columns,
        className: className,
        images: images
    });
}
BlockImageGallery.propTypes = {
    anchor: (prop_types_default()).string,
    caption: (prop_types_default()).string,
    columns: (prop_types_default()).number,
    className: (prop_types_default()).string,
    sizeSlug: (prop_types_default()).string,
    images: prop_types_default().arrayOf(prop_types_default().shape({
        alt: (prop_types_default()).string,
        caption: (prop_types_default()).string,
        fullUrl: (prop_types_default()).string,
        id: (prop_types_default()).string,
        link: (prop_types_default()).string,
        url: (prop_types_default()).string
    }))
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockImageGallery/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockList/BlockList.js



/**
 * List Block
 *
 * The core List block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component props.
 * @param  {string}  props.className Optional classnames.
 * @param  {boolean} props.ordered   Is this an ordered list.
 * @param  {string}  props.anchor    Optional anchor/id.
 * @param  {string}  props.values    The content of the block.
 * @return {Element}                 The RichText component.
 */ function BlockList(param) {
    var className = param.className, ordered = param.ordered, anchor = param.anchor, values = param.values;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
        tag: ordered ? "ol" : "ul",
        className: className,
        id: anchor,
        children: values
    });
}
BlockList.propTypes = {
    anchor: (prop_types_default()).string,
    ordered: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    values: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockList/index.js


// EXTERNAL MODULE: ./components/organisms/MediaText/MediaText.module.css
var MediaText_module = __webpack_require__(83622);
var MediaText_module_default = /*#__PURE__*/__webpack_require__.n(MediaText_module);
;// CONCATENATED MODULE: ./components/organisms/MediaText/MediaText.js







/**
 * Render the MediaText component.
 *
 * @param  {object}  props                   MediaText component props.
 * @param  {string}  props.body              The body text.
 * @param  {Element} props.children          The child elements.
 * @param  {string}  props.className         The className.
 * @param  {object}  props.cta               The cta object with text and url strings.
 * @param  {object}  props.focalPoint        The focal point coordinates for the image fill setting.
 * @param  {string}  props.id                Optional element ID.
 * @param  {object}  props.image             The image object with url and alt text.
 * @param  {boolean} props.imageFill         Whether to crop image to fill.
 * @param  {boolean} props.mediaLeft         Whether to show media on the left of the text.
 * @param  {boolean} props.stackOnMobile     Whether to stack media and text on mobile.
 * @param  {object}  props.style             Custom media text styles.
 * @param  {string}  props.title             The title.
 * @param  {string}  props.verticalAlignment Vertical alignment of text.
 * @return {Element}                         The MediaText component.
 */ function MediaText(param) {
    var body = param.body, children = param.children, className = param.className, cta = param.cta, focalPoint = param.focalPoint, id = param.id, image = param.image, imageFill = param.imageFill, mediaLeft = param.mediaLeft, stackOnMobile = param.stackOnMobile, style = param.style, title = param.title, verticalAlignment = param.verticalAlignment;
    (0,react.useEffect)(function() {
        if (children && title || children && body || children && cta) {
            console.warn("The title, body and cta props are ignored when using children.");
        }
    });
    var imageFillStyle = !imageFill ? null : {
        backgroundImage: "url(".concat((image === null || image === void 0 ? void 0 : image.url) || "", ")"),
        backgroundPosition: "".concat(focalPoint.x, " ").concat(focalPoint.y)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: id,
        className: classnames_default()((MediaText_module_default()).mediaText, mediaLeft ? (MediaText_module_default()).mediaLeft : null, className, !stackOnMobile ? (MediaText_module_default()).noStack : null, verticalAlignment === "top" ? (MediaText_module_default()).alignTop : null, verticalAlignment === "bottom" ? (MediaText_module_default()).alignBottom : null, imageFill && (image === null || image === void 0 ? void 0 : image.url) ? (MediaText_module_default()).imageFill : null),
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MediaText_module_default()).text,
                children: children ? children : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (MediaText_module_default()).title,
                            children: title
                        }),
                        body && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (MediaText_module_default()).body,
                            children: body
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: (MediaText_module_default()).button,
                            url: cta.url ? cta.url : null,
                            text: cta.text ? cta.text : null,
                            icon: cta.icon ? cta.icon : null,
                            type: "primary",
                            size: "md"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MediaText_module_default()).media,
                style: imageFillStyle,
                children: image && image.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayImage, {
                    className: (MediaText_module_default()).imageWrap,
                    alt: image.alt,
                    imageMeta: {
                        mediaItemUrl: image.url,
                        altText: image.alt
                    },
                    nextImageFill: true
                })
            })
        ]
    });
}
MediaText.propTypes = {
    body: (prop_types_default()).string,
    className: (prop_types_default()).string,
    children: (prop_types_default()).element,
    cta: prop_types_default().shape({
        text: (prop_types_default()).string,
        url: (prop_types_default()).string,
        icon: (prop_types_default()).string
    }),
    focalPoint: prop_types_default().shape({
        x: (prop_types_default()).string,
        y: (prop_types_default()).string
    }),
    id: (prop_types_default()).string,
    image: prop_types_default().shape({
        url: (prop_types_default()).string,
        alt: (prop_types_default()).string
    }),
    imageFill: (prop_types_default()).bool,
    mediaLeft: (prop_types_default()).bool,
    stackOnMobile: (prop_types_default()).bool,
    style: prop_types_default().shape({
        background: (prop_types_default()).string,
        backgroundColor: (prop_types_default()).string,
        color: (prop_types_default()).string
    }),
    title: (prop_types_default()).string,
    verticalAlignment: (prop_types_default()).string
};
MediaText.defaultProps = {
    mediaLeft: false
};

;// CONCATENATED MODULE: ./components/organisms/MediaText/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockMediaText/BlockMediaText.js






/**
 * Media & Text Block
 *
 * The core Media & Text block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component properties.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.backgroundColorHex The background color
 * @param  {string}  props.className          The image class name.
 * @param  {object}  props.focalPoint         The focal point coordinates for the image.
 * @param  {string}  props.gradientHex        The background gradient hex value.
 * @param  {boolean} props.imageFill          Whether to crop image to fill.
 * @param  {Array}   props.innerBlocks        The array of inner blocks to display.
 * @param  {boolean} props.isStackedOnMobile  Whether to stack media and text on mobile.
 * @param  {string}  props.mediaAlt           The image alt attribute.
 * @param  {string}  props.mediaPosition      The image position relative to the text.
 * @param  {string}  props.mediaUrl           The media URL.
 * @param  {number}  props.mediaWidth         The image width.
 * @param  {object}  props.style              The style attributes.
 * @param  {string}  props.textColorHex       The text color hex value.
 * @param  {string}  props.verticalAlignment  Vertical alignment of text.
 * @return {Element}                          The Media & Text component.
 */ function BlockMediaText(param) {
    var anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, className = param.className, focalPoint = param.focalPoint, gradientHex = param.gradientHex, imageFill = param.imageFill, innerBlocks = param.innerBlocks, isStackedOnMobile = param.isStackedOnMobile, mediaAlt = param.mediaAlt, mediaPosition = param.mediaPosition, mediaUrl = param.mediaUrl, mediaWidth = param.mediaWidth, style = param.style, textColorHex = param.textColorHex, verticalAlignment = param.verticalAlignment;
    var mediaTextStyle = getBlockStyles({
        backgroundColorHex: backgroundColorHex,
        gradientHex: gradientHex,
        textColorHex: textColorHex,
        style: style
    });
    // Add additional styles.
    var gridtemplatecolumns = mediaPosition === "left" ? "".concat(mediaWidth, "% 1fr") : "1fr ".concat(mediaWidth, "%");
    mediaTextStyle.gridTemplateColumns = gridtemplatecolumns;
    var newFocalPoint = imageFill ? formatFocalPoint(focalPoint) : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!mediaUrl && (innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaText, {
            className: className,
            focalPoint: newFocalPoint,
            id: anchor,
            image: {
                url: mediaUrl,
                alt: mediaAlt
            },
            imageFill: imageFill,
            mediaLeft: mediaPosition === "left" ? true : false,
            mediaWidth: mediaWidth,
            style: mediaTextStyle,
            stackOnMobile: isStackedOnMobile,
            verticalAlignment: verticalAlignment,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks, {
                blocks: innerBlocks
            })
        })
    });
}
BlockMediaText.propTypes = {
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    className: (prop_types_default()).string,
    focalPoint: prop_types_default().shape({
        x: (prop_types_default()).string,
        y: (prop_types_default()).string
    }),
    gradientHex: (prop_types_default()).string,
    imageFill: (prop_types_default()).bool,
    innerBlocks: prop_types_default().arrayOf(prop_types_default().shape({
        attributes: (prop_types_default()).object,
        name: (prop_types_default()).string
    })),
    isStackedOnMobile: (prop_types_default()).bool,
    mediaAlt: (prop_types_default()).string,
    mediaPosition: (prop_types_default()).string,
    mediaUrl: (prop_types_default()).string,
    mediaWidth: (prop_types_default()).number,
    style: (prop_types_default()).object,
    textColorHex: (prop_types_default()).string,
    verticalAlignment: (prop_types_default()).string
};
BlockMediaText.defaultProps = {
    media: prop_types_default().shape({
        mediaPosition: "left"
    })
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockMediaText/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockParagraph/BlockParagraph.js





/**
 * Paragraph Block
 *
 * The core Paragraph block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component props.
 * @param  {string}  props.backgroundColorHex The background color hex value.
 * @param  {string}  props.className          Optional classnames.
 * @param  {string}  props.align              Optional alignment style.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.content            The content of the block.
 * @param  {boolean} props.dropCap            Whether the paragraph has a drop cap.
 * @param  {object}  props.style              The style attributes (Typography panel).
 * @param  {string}  props.textColorHex       The text color hex value.
 * @return {Element}                          The RichText component.
 */ function BlockParagraph(param) {
    var align = param.align, anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, className = param.className, content = param.content, dropCap = param.dropCap, style = param.style, textColorHex = param.textColorHex;
    var paragraphStyle = getBlockStyles({
        backgroundColorHex: backgroundColorHex,
        textColorHex: textColorHex,
        style: style
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
        className: classnames_default()(className, align === "center" ? "text-center" : null, !align || align === "left" ? "text-left" : null, align === "right" ? "text-right" : null),
        id: anchor,
        tag: "p",
        dropCap: dropCap,
        style: paragraphStyle,
        children: content
    });
}
BlockParagraph.propTypes = {
    align: (prop_types_default()).string,
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    className: (prop_types_default()).string,
    content: (prop_types_default()).string,
    dropCap: (prop_types_default()).bool,
    style: (prop_types_default()).object,
    textColorHex: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockParagraph/index.js


// EXTERNAL MODULE: ./components/atoms/PullQuote/PullQuote.module.css
var PullQuote_module = __webpack_require__(26821);
var PullQuote_module_default = /*#__PURE__*/__webpack_require__.n(PullQuote_module);
;// CONCATENATED MODULE: ./components/atoms/PullQuote/PullQuote.js





/**
 * PullQuote Block
 *
 * @author WebDevStudios
 * @param  {object}  props            The component properties.
 * @param  {string}  props.citation   The optional author citation.
 * @param  {string}  props.className  Optional classnames.
 * @param  {string}  props.id         Optional anchor/id.
 * @param  {object}  props.style      Custom pullquote styles.
 * @param  {boolean} props.styleSolid Whether this pullquote has the solid style.
 * @param  {string}  props.value      The pull quote content of the block.
 * @return {Element}                  The PullQuote component.
 */ function PullQuote(param) {
    var citation = param.citation, className = param.className, id = param.id, style = param.style, styleSolid = param.styleSolid, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!value && /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
            id: id ? id : null,
            className: classnames_default()((PullQuote_module_default()).pullquote, className, styleSolid && (PullQuote_module_default()).styleSolid),
            style: style,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PullQuote_module_default()).wrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PullQuote_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                tag: "div",
                                children: value
                            })
                        })
                    }),
                    !!citation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                        className: (PullQuote_module_default()).cite,
                        children: [
                            "~ ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                tag: "span",
                                children: citation
                            })
                        ]
                    })
                ]
            })
        })
    });
}
PullQuote.propTypes = {
    citation: (prop_types_default()).string,
    className: (prop_types_default()).string,
    id: (prop_types_default()).string,
    style: prop_types_default().shape({
        backgroundColor: (prop_types_default()).string,
        color: (prop_types_default()).string
    }),
    styleSolid: (prop_types_default()).bool,
    value: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/atoms/PullQuote/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockPullQuote/BlockPullQuote.js



/**
 * Pull Quote Block
 *
 * The core Pull Quote block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                 The component props.
 * @param  {string}  props.anchor          Optional anchor/id.
 * @param  {string}  props.citation        The optional author citation.
 * @param  {string}  props.className       Optional classnames.
 * @param  {string}  props.customMainColor The custom background color.
 * @param  {string}  props.customTextColor The custom text color.
 * @param  {string}  props.mainColorHex    The background color hex value.
 * @param  {string}  props.textColorHex    The text color hex value.
 * @param  {string}  props.value           The quote content of the block.
 * @return {Element}                       The Quote component.
 */ function BlockPullQuote(param) {
    var anchor = param.anchor, citation = param.citation, className = param.className, customMainColor = param.customMainColor, customTextColor = param.customTextColor, mainColorHex = param.mainColorHex, textColorHex = param.textColorHex, value = param.value;
    // Determine background and text colors, using stylelint-accepted const names.
    var backgroundcolor = mainColorHex || customMainColor || "inherit";
    var textcolor = textColorHex || customTextColor || "inherit";
    // Create style object for pullquote.
    var pullQuoteStyle = {
        backgroundColor: backgroundcolor,
        color: textcolor
    };
    // Extract pullquote style.
    var styleSolid = className && className.includes("is-style-solid-color");
    // Remove styles from className.
    className && className.replace("is-style-solid-color", "").replace("is-style-default", "");
    // Remove background for default style.
    if (!styleSolid) {
        pullQuoteStyle.backgroundColor = "inherit";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PullQuote, {
        citation: citation,
        className: className,
        id: anchor,
        style: pullQuoteStyle,
        styleSolid: styleSolid,
        value: value
    });
}
BlockPullQuote.propTypes = {
    anchor: (prop_types_default()).string,
    citation: (prop_types_default()).string,
    className: (prop_types_default()).string,
    customMainColor: (prop_types_default()).string,
    customTextColor: (prop_types_default()).string,
    mainColorHex: (prop_types_default()).string,
    textColorHex: (prop_types_default()).string,
    value: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockPullQuote/index.js


// EXTERNAL MODULE: ./components/atoms/Quote/Quote.module.css
var Quote_module = __webpack_require__(80892);
var Quote_module_default = /*#__PURE__*/__webpack_require__.n(Quote_module);
;// CONCATENATED MODULE: ./components/atoms/Quote/Quote.js





/**
 * Quote Block
 *
 * The core Quote block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component properties.
 * @param  {string}  props.value     The quote content of the block.
 * @param  {string}  props.citation  The optional author citation.
 * @param  {string}  props.id        Optional anchor/id.
 * @param  {string}  props.className Optional classnames.
 * @return {Element}                 The Quote component.
 */ function Quote(param) {
    var value = param.value, citation = param.citation, id = param.id, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!value && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
            id: id ? id : null,
            className: classnames_default()((Quote_module_default()).quote, className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Quote_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                            tag: "div",
                            children: value
                        })
                    })
                }),
                !!citation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                    className: (Quote_module_default()).cite,
                    children: [
                        "~ ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                            tag: "span",
                            children: citation
                        })
                    ]
                })
            ]
        })
    });
}
Quote.propTypes = {
    id: (prop_types_default()).string,
    className: (prop_types_default()).string,
    value: (prop_types_default()).string,
    citation: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/atoms/Quote/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockQuote/BlockQuote.js



/**
 * Quote Block
 *
 * The core Quote block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component props.
 * @param  {string}  props.value     The quote content of the block.
 * @param  {string}  props.citation  The optional author citation.
 * @param  {string}  props.anchor    Optional anchor/id.
 * @param  {string}  props.className Optional classnames.
 * @return {Element}                 The Quote component.
 */ function BlockQuote(param) {
    var value = param.value, citation = param.citation, anchor = param.anchor, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote, {
        id: anchor,
        className: className,
        value: value,
        citation: citation
    });
}
BlockQuote.propTypes = {
    value: (prop_types_default()).string,
    citation: (prop_types_default()).string,
    anchor: (prop_types_default()).string,
    className: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockQuote/index.js


// EXTERNAL MODULE: ./components/atoms/Separator/Separator.module.css
var Separator_module = __webpack_require__(58326);
var Separator_module_default = /*#__PURE__*/__webpack_require__.n(Separator_module);
;// CONCATENATED MODULE: ./components/atoms/Separator/Separator.js





/**
 * Render the Separator component.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component properties.
 * @param  {string}  props.anchor    Optional anchor/id.
 * @param  {string}  props.className Optional classname.
 * @param  {boolean} props.fullWidth Is this a fullwidth block.
 * @return {Element}                 The Separator component.
 */ function Separator(param) {
    var anchor = param.anchor, className = param.className, fullWidth = param.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
        id: anchor,
        className: classnames_default()((Separator_module_default()).separator, !fullWidth && (Separator_module_default()).containerWidth, className)
    });
}
Separator.propTypes = {
    anchor: (prop_types_default()).string,
    className: (prop_types_default()).string,
    fullWidth: (prop_types_default()).bool.isRequired
};
Separator.defaultProps = {
    fullWidth: false
};

;// CONCATENATED MODULE: ./components/atoms/Separator/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockSeparator/BlockSeparator.js



/**
 * Separator Block
 *
 * The core Separator block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component attributes as props.
 * @param  {string}  props.className Optional classnames.
 * @param  {string}  props.anchor    Optional anchor/id.
 * @return {Element}                 The Separator component.
 */ function BlockSeparator(param) {
    var className = param.className, anchor = param.anchor;
    var isFullWidth = (className && className.includes("is-style-full-width")) > 0 ? true : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {
        className: className,
        anchor: anchor,
        fullWidth: isFullWidth
    });
}
BlockSeparator.propTypes = {
    className: (prop_types_default()).string,
    anchor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockSeparator/index.js


;// CONCATENATED MODULE: ./components/atoms/Spacer/Spacer.js



/**
 * Render the Spacer component.
 *
 * @author WebDevStudios
 * @param  {object}  props        The component properties.
 * @param  {string}  props.anchor Optional anchor/id.
 * @param  {number}  props.height The height of the spacer.
 * @return {Element}              The Spacer component.
 */ function Spacer(param) {
    var height = param.height, anchor = param.anchor;
    var rootEmVal = 16;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: anchor || null,
        style: {
            /* stylelint-disable-next-line value-keyword-case */ height: "".concat(height / rootEmVal, "rem")
        },
        "aria-hidden": "true"
    });
}
Spacer.propTypes = {
    anchor: (prop_types_default()).string,
    height: (prop_types_default()).number.isRequired
};
Spacer.defaultProps = {
    height: 40
};

;// CONCATENATED MODULE: ./components/atoms/Spacer/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockSpacer/BlockSpacer.js



/**
 * Spacer Block
 *
 * The core Spacer block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props        The component attributes as props.
 * @param  {string}  props.anchor Optional anchor/id.
 * @param  {number}  props.height The height of the spacer.
 * @return {Element}              The Spacer component.
 */ function BlockSpacer(param) {
    var anchor = param.anchor, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {
        height: height,
        id: anchor
    });
}
BlockSpacer.propTypes = {
    anchor: (prop_types_default()).string,
    height: (prop_types_default()).number
};
BlockSpacer.defaultProps = {
    height: 40
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockSpacer/index.js


// EXTERNAL MODULE: ./components/atoms/Table/Table.module.css
var Table_module = __webpack_require__(16997);
var Table_module_default = /*#__PURE__*/__webpack_require__.n(Table_module);
;// CONCATENATED MODULE: ./components/atoms/Table/Table.js





/**
 * Table Block
 *
 * @author WebDevStudios
 * @param  {object}  props           The component properties.
 * @param  {string}  props.id        Optional anchor/id.
 * @param  {Array}   props.head      The optional table head array.
 * @param  {Array}   props.body      The table body array.
 * @param  {Array}   props.foot      The optional table foorter array.
 * @param  {string}  props.caption   Optional table caption.
 * @param  {string}  props.className Optional classnames.
 * @return {Element}                 The Table component.
 */ function Table(param) {
    var id = param.id, head = param.head, body = param.body, foot = param.foot, caption = param.caption, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!body.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Table_module_default()).table, className),
            id: id || null,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    children: [
                        !!(head === null || head === void 0 ? void 0 : head.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: head.map(function(row, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                    children: !!(row === null || row === void 0 ? void 0 : row.cells) && row.cells.map(function(cell, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                            tag: "th",
                                            className: classnames_default()((cell === null || cell === void 0 ? void 0 : cell.align) === "center" ? "text-center" : null, !(cell === null || cell === void 0 ? void 0 : cell.align) || cell.align === "left" ? "text-left" : null, (cell === null || cell === void 0 ? void 0 : cell.align) === "right" ? "text-right" : null),
                                            children: cell.content
                                        }, index);
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: body.map(function(row, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                    children: !!(row === null || row === void 0 ? void 0 : row.cells) && row.cells.map(function(cell, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                            tag: "td",
                                            className: (cell === null || cell === void 0 ? void 0 : cell.align) !== "" ? "text-".concat(cell.align) : "text-left",
                                            children: cell.content
                                        }, index);
                                    })
                                }, index);
                            })
                        }),
                        !!(foot === null || foot === void 0 ? void 0 : foot.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                            children: foot.map(function(row, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                    children: !!(row === null || row === void 0 ? void 0 : row.cells) && row.cells.map(function(cell, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                            tag: "td",
                                            className: (cell === null || cell === void 0 ? void 0 : cell.align) !== "" ? "text-".concat(cell.align) : "text-left",
                                            children: cell.content
                                        }, index);
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                !!caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Table_module_default()).caption,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        tag: "span",
                        children: caption
                    })
                })
            ]
        })
    });
}
Table.propTypes = {
    id: (prop_types_default()).string,
    head: (prop_types_default()).array,
    body: (prop_types_default()).array,
    foot: (prop_types_default()).array,
    caption: (prop_types_default()).string,
    className: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/atoms/Table/index.js


;// CONCATENATED MODULE: ./components/blocks/core/BlockTable/BlockTable.js



/**
 * Paragraph Block
 *
 * The core Paragraph block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props           The component props.
 * @param  {string}  props.anchor    Optional anchor/id.
 * @param  {Array}   props.body      The body blocks.
 * @param  {string}  props.caption   The caption.
 * @param  {string}  props.className Optional classnames.
 * @param  {Array}   props.foot      The foot blocks
 * @param  {Array}   props.head      The head blocks.
 * @return {Element}                 The RichText component.
 */ function BlockTable(param) {
    var anchor = param.anchor, body = param.body, caption = param.caption, className = param.className, foot = param.foot, head = param.head;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
        id: anchor,
        className: className,
        tag: "p",
        head: head,
        body: body,
        foot: foot,
        caption: caption
    });
}
BlockTable.propTypes = {
    anchor: (prop_types_default()).string,
    className: (prop_types_default()).string,
    head: (prop_types_default()).array,
    body: (prop_types_default()).array,
    foot: (prop_types_default()).array,
    caption: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockTable/index.js


// EXTERNAL MODULE: ./components/blocks/core/BlockVideo/Video.module.scss
var Video_module = __webpack_require__(27772);
var Video_module_default = /*#__PURE__*/__webpack_require__.n(Video_module);
// EXTERNAL MODULE: ./components/atoms/Video/Video.module.scss
var Video_Video_module = __webpack_require__(79041);
var Video_Video_module_default = /*#__PURE__*/__webpack_require__.n(Video_Video_module);
// EXTERNAL MODULE: ./components/molecules/Loading/Loading.js
var Loading = __webpack_require__(42409);
;// CONCATENATED MODULE: ./components/molecules/Loading/index.js


;// CONCATENATED MODULE: ./components/atoms/Video/Video.tsx






function Video(param) {
    var video = param.video, autoplay = param.autoplay;
    var ref = (0,react.useState)(false), isVideoPlaying = ref[0], setIsVideoPlaying = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var vidRef = (0,react.useRef)(null);
    var handlePlayVideo = function() {
        if (!isVideoPlaying) {
            var ref;
            (ref = vidRef.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            (ref1 = vidRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
        setIsVideoPlaying(!isVideoPlaying);
    };
    (0,react.useEffect)(function() {
        if (autoplay) setIsVideoPlaying(true);
    }, [
        autoplay
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function() {
            return handlePlayVideo();
        },
        className: classnames_default()((Video_Video_module_default()).video, isVideoPlaying ? (Video_Video_module_default()).isPlaying : ""),
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Video_Video_module_default()).loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: vidRef,
                preload: "metadata",
                muted: autoplay,
                "webkit-playsinline": true,
                playsInline: true,
                autoPlay: autoplay,
                loop: autoplay,
                onLoadStart: function() {
                    return setIsLoading(true);
                },
                onLoadedData: function() {
                    return setIsLoading(false);
                },
                onEnded: function() {
                    var ref;
                    setIsVideoPlaying(false);
                    if (!autoplay) vidRef === null || vidRef === void 0 ? void 0 : (ref = vidRef.current) === null || ref === void 0 ? void 0 : ref.load();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: video.mediaItemUrl + "#t=0.5s"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                className: (Video_Video_module_default()).icon,
                icon: isVideoPlaying ? "pauseCircle" : "playCircle",
                size: 32,
                sizeViewbox: 32
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/atoms/Video/index.ts


;// CONCATENATED MODULE: ./components/blocks/core/BlockVideo/BlockVideo.tsx




function BlockVideo_Video(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Video_module_default()).videoWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                video: block
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/core/BlockVideo/index.ts


// EXTERNAL MODULE: ./components/atoms/Icon/Icon.tsx + 1 modules
var Icon_Icon = __webpack_require__(71347);
// EXTERNAL MODULE: ./components/atoms/Label/index.ts + 1 modules
var Label = __webpack_require__(96184);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(31838);
// EXTERNAL MODULE: ./functions/useMediaQuery.js
var useMediaQuery = __webpack_require__(47141);
// EXTERNAL MODULE: ./node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__(56180);
// EXTERNAL MODULE: ./components/blocks/custom/FAQs/FAQs.module.scss
var FAQs_module = __webpack_require__(91905);
var FAQs_module_default = /*#__PURE__*/__webpack_require__.n(FAQs_module);
;// CONCATENATED MODULE: ./components/blocks/custom/FAQs/FAQ.tsx







var FAQ = function(param) {
    var question = param.question, answer = param.answer, link = param.link, index = param.index;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function() {
            return setShow(!show);
        },
        className: classnames_default()((FAQs_module_default()).faqWrapper, show ? (FAQs_module_default()).isActive : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-in",
                "data-aos-delay": "".concat((index + 1) * 100),
                className: (FAQs_module_default()).questionWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FAQs_module_default()).question,
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        size: 32,
                        sizeViewbox: 32,
                        icon: "plus",
                        className: classnames_default()((FAQs_module_default()).plusIcon, show ? (FAQs_module_default()).isOpen : "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapse_lib.Collapse, {
                    isOpened: show,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((FAQs_module_default()).answerWrapper, show ? (FAQs_module_default()).isActive : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FAQs_module_default()).answer,
                                dangerouslySetInnerHTML: {
                                    __html: answer
                                }
                            }),
                            (link === null || link === void 0 ? void 0 : link.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (FAQs_module_default()).button,
                                type: "blue",
                                text: link.title,
                                url: link.url,
                                urlExternal: link.target
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var FAQs_FAQ = (FAQ);

// EXTERNAL MODULE: ./components/blocks/custom/Contacts/Contacts.module.scss
var Contacts_module = __webpack_require__(35426);
var Contacts_module_default = /*#__PURE__*/__webpack_require__.n(Contacts_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Contacts/Contacts.tsx










function Contacts(param) {
    var block = param.block;
    var title = block.title, cards = block.cards;
    var isMd = (0,useMediaQuery/* default */.Z)(config.md);
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(false), fadeOut = ref1[0], setFadeOut = ref1[1];
    var fadeOutFunction = function(index) {
        setFadeOut(true);
        setTimeout(function() {
            setActive(index);
            setFadeOut(false);
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        removePaddingMobile: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Contacts_module_default()).contacts,
            children: [
                isMd && (cards === null || cards === void 0 ? void 0 : cards.length) > 0 && cards[active] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Contacts_module_default()).text, fadeOut ? (Contacts_module_default()).fadeOut : (Contacts_module_default()).fadeIn),
                    dangerouslySetInnerHTML: {
                        __html: cards[active].text
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Contacts_module_default()).tabs,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-aos": "fade-in",
                            className: (Contacts_module_default()).labelWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                hasParent: true,
                                title: title,
                                isSmall: true,
                                removeBorders: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Contacts_module_default()).listWrapper,
                            children: (cards === null || cards === void 0 ? void 0 : cards.length) > 0 && cards.map(function(card, index) {
                                return isMd ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: function() {
                                        return fadeOutFunction(index);
                                    },
                                    className: classnames_default()((Contacts_module_default()).title, index === active ? (Contacts_module_default()).isActive : ""),
                                    children: [
                                        card.title,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_Icon/* default */.Z, {
                                            icon: "arrowRightContacts",
                                            size: 32,
                                            sizeViewbox: 32
                                        })
                                    ]
                                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs_FAQ, {
                                    index: index,
                                    question: card.title,
                                    answer: card.text
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Contacts/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/Facts/Facts.module.scss
var Facts_module = __webpack_require__(35497);
var Facts_module_default = /*#__PURE__*/__webpack_require__.n(Facts_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Facts/Facts.tsx





function Facts(param) {
    var block = param.block;
    var image = block.image, title = block.title, link = block.link, facts = block.facts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                title: title,
                link: link
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Facts_module_default()).imageFactsWrapper,
                    children: [
                        (image === null || image === void 0 ? void 0 : image.mediaItemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Facts_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                "data-aos": "fade-in",
                                src: image.mediaItemUrl,
                                alt: image.altText,
                                width: image.mediaDetails.width,
                                height: image.mediaDetails.height,
                                layout: "responsive",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Facts_module_default()).factsWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Facts_module_default()).factsContainer,
                                children: (facts === null || facts === void 0 ? void 0 : facts.length) > 0 && facts.map(function(fact, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        "data-aos": "fade-up",
                                        className: (Facts_module_default()).factWrapper,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Facts_module_default()).factTitle,
                                                children: fact.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Facts_module_default()).factText,
                                                children: fact.text
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Facts/index.ts


// EXTERNAL MODULE: ./components/atoms/CircleAnimation/CircleAnimation.module.scss
var CircleAnimation_module = __webpack_require__(8407);
var CircleAnimation_module_default = /*#__PURE__*/__webpack_require__.n(CircleAnimation_module);
;// CONCATENATED MODULE: ./components/atoms/CircleAnimation/CircleAnimationSVG.tsx

function CircleAnimationSVG() {
    // prettier-ignore
    /* eslint-disable */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "106",
        height: "106",
        viewBox: "0 0 106 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M97.5959 26.0969C102.365 33.9588 105.111 43.1861 105.111 53.0551C105.111 80.6562 83.6283 103.241 56.4715 105H56.4688",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.67454 25.836C8.67454 25.8388 8.67065 25.8427 8.66953 25.8455C3.80454 33.7636 1 43.0815 1 53.0567C1 80.4148 22.1039 102.843 48.9214 104.951H48.9281",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.0776 19.7142L13.0843 19.7064C21.806 9.26403 34.5424 2.29188 48.9216 1.16239C50.2852 1.05413 51.6626 1 53.0536 1C54.203 1 55.3423 1.03708 56.4716 1.11123C71.2529 2.06887 84.3535 9.19674 93.2232 19.9439L93.2271 19.9478",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M95.8339 44.8511C96.348 47.556 96.6065 50.3034 96.6058 53.0567C96.6058 77.1081 77.108 96.6059 53.0555 96.6059C49.2247 96.6089 45.4102 96.107 41.7106 95.1132C41.3969 95.0291 41.0844 94.9412 40.7729 94.8496",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.3436 21.2163C14.8282 29.1639 9.50439 40.4894 9.50439 53.0567C9.50439 70.1732 19.3801 84.985 33.7459 92.1035",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M70.2185 13.0201C81.0307 17.6599 89.5873 26.5518 93.7816 37.5942",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M29.2817 16.5637C29.4197 16.472 29.5598 16.3824 29.6994 16.2934C34.6052 13.1833 40.0822 11.0832 45.8098 10.1161C51.5373 9.14891 57.4002 9.33417 63.0553 10.661",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M51.3799 18.0775C51.936 18.0508 52.4945 18.0377 53.0555 18.038C61.4173 18.0259 69.505 21.0185 75.845 26.4706",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M30.7024 80.0127C36.9797 85.2347 44.8905 88.0884 53.0559 88.0765C68.5162 88.0765 81.6357 78.0574 86.2783 64.1587",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M25.448 74.5999C20.635 68.4514 18.0256 60.865 18.0381 53.0567C18.0381 36.8734 29.0138 23.255 43.9291 19.2404",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M81.0115 31.9645C85.606 38.0353 88.0866 45.4434 88.0743 53.0567C88.0745 54.3025 88.0088 55.5473 87.8774 56.7861",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M72.8562 70.6865C76.8829 66.1786 79.2404 60.4253 79.5347 54.3881",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.7314 49.8835C28.3003 36.7361 39.4879 26.544 53.0534 26.544C55.6188 26.5418 58.1708 26.9125 60.6295 27.6446",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.9023 57.4223C28.9845 69.9869 39.9018 79.5678 53.0536 79.5678C58.0175 79.5766 62.883 78.1843 67.0908 75.5509",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.4786 30.8083C67.6889 30.944 67.8963 31.0829 68.1009 31.2249C73.4008 34.8836 77.3032 40.4227 78.8431 46.8776",
                        stroke: "#0567EC",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/atoms/CircleAnimation/CircleAnimation.tsx



function CircleAnimation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CircleAnimation_module_default()).circle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CircleAnimation_module_default()).circleContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleAnimationSVG, {})
        })
    });
}

;// CONCATENATED MODULE: ./components/atoms/CircleAnimation/index.ts


// EXTERNAL MODULE: ./components/atoms/EllipseAnimation/EllipseAnimation.module.scss
var EllipseAnimation_module = __webpack_require__(63865);
var EllipseAnimation_module_default = /*#__PURE__*/__webpack_require__.n(EllipseAnimation_module);
;// CONCATENATED MODULE: ./components/atoms/EllipseAnimation/EllipseAnimation.tsx


function EllipseAnimation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (EllipseAnimation_module_default()).circle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (EllipseAnimation_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EllipseAnimation_module_default()).visual,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (EllipseAnimation_module_default()).round
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/atoms/EllipseAnimation/index.ts


// EXTERNAL MODULE: ./components/atoms/SquareAnimation/SquareAnimation.module.scss
var SquareAnimation_module = __webpack_require__(80937);
var SquareAnimation_module_default = /*#__PURE__*/__webpack_require__.n(SquareAnimation_module);
;// CONCATENATED MODULE: ./components/atoms/SquareAnimation/SquareAnimation.tsx


function SquareAnimation() {
    var items = new Array(36).fill(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SquareAnimation_module_default()).animation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SquareAnimation_module_default()).gridWrapper,
            children: items.map(function(_, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SquareAnimation_module_default()).grid
                }, index);
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/atoms/SquareAnimation/index.ts


;// CONCATENATED MODULE: ./components/atoms/Animation/Animation.tsx






function Animation(param) {
    var animation = param.animation;
    var isLg = (0,useMediaQuery/* default */.Z)(config.lg);
    if (animation === "circle" && isLg) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleAnimation, {});
    if (animation === "inner-circle" && isLg) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipseAnimation, {});
    if (animation === "square" && isLg) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareAnimation, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

;// CONCATENATED MODULE: ./components/atoms/Animation/index.ts


;// CONCATENATED MODULE: ./components/blocks/custom/FAQs/FAQs.tsx










function FAQs(param) {
    var block = param.block;
    var faqs = block.faqs, title = block.title, isHighlights = block.isHighlights, animation = block.animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            !isHighlights && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-aos": "fade-in",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                    title: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((FAQs_module_default()).wrapper, isHighlights ? (FAQs_module_default()).isHighlights : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((FAQs_module_default()).faqsWrapper, isHighlights ? (FAQs_module_default()).isHighlights : ""),
                            children: [
                                isHighlights && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FAQs_module_default()).labelWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        hasParent: true,
                                        title: title,
                                        isSmall: true,
                                        removeBorders: true
                                    })
                                }),
                                faqs.map(function(faq, index) {
                                    return /*#__PURE__*/ (0,react.createElement)(FAQs_FAQ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, faq), {
                                        index: index,
                                        key: index
                                    }));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FAQs_module_default()).animationWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, {
                                animation: animation
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/FAQs/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/Image/Image.module.scss
var Image_Image_module = __webpack_require__(64147);
var Image_Image_module_default = /*#__PURE__*/__webpack_require__.n(Image_Image_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Image/Image.tsx





function ImageBlock(param) {
    var block = param.block;
    var image = block.image, animation = block.animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        removePaddingMobile: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Image_Image_module_default()).imageAnimationWrapper,
            children: [
                (image === null || image === void 0 ? void 0 : image.mediaItemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Image_Image_module_default()).imageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        "data-aos": "fade-in",
                        alt: image.altText,
                        src: image.mediaItemUrl,
                        width: image.mediaDetails.width,
                        height: image.mediaDetails.height,
                        layout: "responsive",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, {
                    animation: animation
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Image/index.ts


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/blocks/custom/ImageLink/ImageLink.module.scss
var ImageLink_module = __webpack_require__(91243);
var ImageLink_module_default = /*#__PURE__*/__webpack_require__.n(ImageLink_module);
;// CONCATENATED MODULE: ./components/blocks/custom/ImageLink/ImageLink.tsx






function ImageLink(param) {
    var block = param.block;
    var cards = block.cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (cards === null || cards === void 0 ? void 0 : cards.length) > 0 && cards.map(function(card, index) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: (ImageLink_module_default()).imageLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    removePaddingMobile: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ImageLink_module_default()).card,
                        children: [
                            (card === null || card === void 0 ? void 0 : (ref = card.link) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: card === null || card === void 0 ? void 0 : card.link.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: (ImageLink_module_default()).textWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            attributes: {
                                                "data-aos": "fade-up"
                                            },
                                            type: "blueDark",
                                            className: (ImageLink_module_default()).button,
                                            text: card === null || card === void 0 ? void 0 : card.link.title,
                                            urlExternal: card.link.target
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-aos": "fade-up",
                                            className: (ImageLink_module_default()).text,
                                            children: card === null || card === void 0 ? void 0 : card.text
                                        })
                                    ]
                                })
                            }),
                            (card === null || card === void 0 ? void 0 : (ref1 = card.image) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ImageLink_module_default()).imageWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    "data-aos": "fade-in",
                                    src: card === null || card === void 0 ? void 0 : card.image.mediaItemUrl,
                                    alt: card === null || card === void 0 ? void 0 : card.image.altText,
                                    width: card === null || card === void 0 ? void 0 : card.image.mediaDetails.width,
                                    height: card === null || card === void 0 ? void 0 : card.image.mediaDetails.height,
                                    layout: "responsive",
                                    objectFit: "cover"
                                })
                            })
                        ]
                    })
                })
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/ImageLink/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/ImageText/ImageText.module.scss
var ImageText_module = __webpack_require__(55217);
var ImageText_module_default = /*#__PURE__*/__webpack_require__.n(ImageText_module);
;// CONCATENATED MODULE: ./components/blocks/custom/ImageText/ImageText.tsx






function ImageText(param) {
    var block = param.block;
    var cards = block.cards, removePaddingBottom = block.removePaddingBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: (cards === null || cards === void 0 ? void 0 : cards.length) > 0 && cards.map(function(card, index) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((ImageText_module_default()).imageTextWrapper, cards.length === 1 ? (ImageText_module_default()).onlyChild : "", removePaddingBottom ? (ImageText_module_default()).removePaddingBottom : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageText_module_default()).textWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ImageText_module_default()).textContainer,
                            children: [
                                (card === null || card === void 0 ? void 0 : (ref = card.label) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: (ImageText_module_default()).label,
                                    children: card.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: (ImageText_module_default()).title,
                                    children: card.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: (ImageText_module_default()).text,
                                    dangerouslySetInnerHTML: {
                                        __html: card.text
                                    }
                                }),
                                (card === null || card === void 0 ? void 0 : (ref1 = card.link) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    attributes: {
                                        "data-aos": "fade-up"
                                    },
                                    type: "blue",
                                    className: (ImageText_module_default()).button,
                                    text: card.link.title,
                                    icon: "arrowOutWard",
                                    iconSize: 42,
                                    url: card.link.url,
                                    urlExternal: card.link.target
                                })
                            ]
                        })
                    }),
                    card.image && card.image.mediaItemUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageText_module_default()).imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            "data-aos": "fade-in",
                            src: card.image.mediaItemUrl,
                            alt: card.image.altText,
                            width: card.image.mediaDetails.width,
                            height: card.image.mediaDetails.height,
                            layout: "responsive",
                            objectFit: "cover"
                        })
                    })
                ]
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/ImageText/index.ts


// EXTERNAL MODULE: ./components/atoms/Button/Button.tsx
var Button_Button = __webpack_require__(87408);
// EXTERNAL MODULE: ./components/blocks/custom/Intro/Intro.module.scss
var Intro_module = __webpack_require__(12250);
var Intro_module_default = /*#__PURE__*/__webpack_require__.n(Intro_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Intro/Intro.tsx





function Intro(param) {
    var block = param.block;
    var text = block.text, link = block.link, animation = block.animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Intro_module_default()).intro,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Intro_module_default()).textWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Intro_module_default()).textContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                "data-aos": "fade-up",
                                className: (Intro_module_default()).text,
                                dangerouslySetInnerHTML: {
                                    __html: text
                                }
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                attributes: {
                                    "data-aos": "fade-up"
                                },
                                type: "primary",
                                url: link.url,
                                text: link.title,
                                urlExternal: link.target
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, {
                    animation: animation
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Intro/index.ts


;// CONCATENATED MODULE: ./components/blocks/custom/Label/Label.tsx



function Label_Intro(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, (0,_object_spread/* default */.Z)({}, block));
}

;// CONCATENATED MODULE: ./components/blocks/custom/Label/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/Locations/Locations.module.scss
var Locations_module = __webpack_require__(66264);
var Locations_module_default = /*#__PURE__*/__webpack_require__.n(Locations_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Locations/Locations.tsx







function Locations(param) {
    var block = param.block;
    var title = block.title, link = block.link, locations = block.locations;
    var isMd = (0,useMediaQuery/* default */.Z)(config.md);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                title: title,
                link: link
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                removePaddingMobile: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Locations_module_default()).servicesSubWrapper,
                    children: (locations === null || locations === void 0 ? void 0 : locations.length) > 0 && locations.map(function(location, index) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                            href: location.title.url,
                            className: (Locations_module_default()).serviceSubWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Locations_module_default()).serviceSubContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        attributes: {
                                            "data-aos": "fade-up"
                                        },
                                        tag: "div",
                                        type: "blue",
                                        text: location === null || location === void 0 ? void 0 : (ref = location.title) === null || ref === void 0 ? void 0 : ref.title,
                                        className: (Locations_module_default()).title,
                                        icon: isMd ? null : "arrowRightOutline"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-aos": "fade-up",
                                        className: (Locations_module_default()).text,
                                        children: location === null || location === void 0 ? void 0 : location.text
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Locations/index.ts


// EXTERNAL MODULE: ./lib/wordpress/connector.js
var wordpress_connector = __webpack_require__(84096);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
;// CONCATENATED MODULE: ./components/molecules/Map/MapStyles.js
var mapStyles = [
    {
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5"
            }
        ]
    },
    {
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#616161"
            }
        ]
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#f5f5f5"
            }
        ]
    },
    {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#bdbdbd"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#eeeeee"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#757575"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#e5e5e5"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#757575"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            {
                color: "#dadada"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#616161"
            }
        ]
    },
    {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e"
            }
        ]
    },
    {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [
            {
                color: "#e5e5e5"
            }
        ]
    },
    {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
            {
                color: "#eeeeee"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#c9c9c9"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e"
            }
        ]
    }
];

;// CONCATENATED MODULE: ./components/molecules/Map/Map.js





function Map(param) {
    var latitude = param.latitude, longitude = param.longitude;
    var center = {
        lat: Number(latitude),
        lng: Number(longitude)
    };
    var isLoaded = (0,esm/* useJsApiLoader */.Ji)({
        id: "google-map-script",
        googleMapsApiKey: wordpress_connector/* googleMapsApiKey */.iO
    }).isLoaded;
    var ref = (0,react.useState)(null), setMap = ref[1];
    var ref1 = (0,react.useState)(5), zoom = ref1[0], setZoom = ref1[1];
    var ref2 = (0,react.useState)(null), googleSettings = ref2[0], setGoogleSettings = ref2[1];
    (0,react.useEffect)(function() {
        if ( true && window.google) {
            setGoogleSettings(window.google.maps);
        }
    }, [
        isLoaded
    ]);
    var onLoad = (0,react.useCallback)(function callback(map) {
        var bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map);
        setTimeout(function() {
            setZoom(16);
        }, 300);
    }, [
        center
    ]);
    var onUnmount = (0,react.useCallback)(function callback() {
        setMap(null);
    }, []);
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
        mapContainerStyle: {
            height: "400px",
            margin: "0 auto"
        },
        center: center,
        onLoad: onLoad,
        onUnmount: onUnmount,
        zoom: zoom,
        options: {
            zoomControlOptions: googleSettings ? {
                position: googleSettings.ControlPosition.TOP_RIGHT,
                style: googleSettings.ZoomControlStyle.SMALL
            } : undefined,
            mapTypeControlOptions: googleSettings ? {
                position: googleSettings.ControlPosition.TOP_LEFT
            } : undefined,
            streetViewControlOptions: googleSettings ? {
                position: googleSettings.ControlPosition.TOP_RIGHT
            } : undefined,
            styles: mapStyles
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
            position: center
        })
    }) : null;
}

;// CONCATENATED MODULE: ./components/molecules/Map/index.js


// EXTERNAL MODULE: ./components/blocks/custom/LocationsLinks/LocationsLinks.module.scss
var LocationsLinks_module = __webpack_require__(40008);
var LocationsLinks_module_default = /*#__PURE__*/__webpack_require__.n(LocationsLinks_module);
;// CONCATENATED MODULE: ./components/blocks/custom/LocationsLinks/LocationsLinks.tsx







function LocationsLinks_Locations(param) {
    var block = param.block;
    var title = block.title, locations = block.locations, animation = block.animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LocationsLinks_module_default()).locationsLinks,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LocationsLinks_module_default()).locationsWrapper,
                        children: [
                            (locations === null || locations === void 0 ? void 0 : locations.length) > 0 && locations.map(function(location, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    id: location.anchor,
                                    className: (LocationsLinks_module_default()).location,
                                    children: [
                                        location.latitude && location.longitude && /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                                            latitude: location.latitude,
                                            longitude: location.longitude
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LocationsLinks_module_default()).textWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "data-aos": "fade-up",
                                                    className: (LocationsLinks_module_default()).title,
                                                    children: location === null || location === void 0 ? void 0 : location.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "data-aos": "fade-up",
                                                    className: (LocationsLinks_module_default()).subtitle,
                                                    children: location === null || location === void 0 ? void 0 : location.subtitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "data-aos": "fade-up",
                                                    className: (LocationsLinks_module_default()).address,
                                                    dangerouslySetInnerHTML: {
                                                        __html: location === null || location === void 0 ? void 0 : location.address
                                                    }
                                                }),
                                                (location === null || location === void 0 ? void 0 : (ref = location.link) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    attributes: {
                                                        "data-aos": "fade-up"
                                                    },
                                                    type: "blue",
                                                    className: (LocationsLinks_module_default()).button,
                                                    text: location.link.title,
                                                    icon: "arrowOutWard",
                                                    iconSize: 42,
                                                    url: location === null || location === void 0 ? void 0 : location.link.url,
                                                    urlExternal: location.link.target
                                                })
                                            ]
                                        })
                                    ]
                                }, index);
                            }),
                            (locations === null || locations === void 0 ? void 0 : locations.length) % 2 !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LocationsLinks_module_default()).animationWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, {
                                    animation: animation
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/LocationsLinks/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/Logos/Logos.module.scss
var Logos_module = __webpack_require__(42531);
var Logos_module_default = /*#__PURE__*/__webpack_require__.n(Logos_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Logos/Logos.tsx




function Logos(param) {
    var block = param.block;
    var logos = block.logos;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        removePaddingMobile: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Logos_module_default()).logos,
            children: (logos === null || logos === void 0 ? void 0 : logos.length) > 0 && (logos === null || logos === void 0 ? void 0 : logos.map(function(logo, index) {
                return logo.image.mediaItemUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Logos_module_default()).image,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Logos_module_default()).imageWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Logos_module_default()).imageContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                "data-aos": "fade-in",
                                src: logo.image.mediaItemUrl,
                                alt: logo.image.altText,
                                width: logo.image.mediaDetails.width,
                                height: logo.image.mediaDetails.height,
                                layout: "responsive",
                                objectFit: "contain"
                            })
                        }, index)
                    }, index)
                }, index);
            }))
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Logos/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/RelatedPosts/index.ts + 1 modules
var RelatedPosts = __webpack_require__(23566);
// EXTERNAL MODULE: ./components/blocks/custom/Services/Services.module.scss
var Services_module = __webpack_require__(59843);
var Services_module_default = /*#__PURE__*/__webpack_require__.n(Services_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Services/Services.tsx









function Services(param) {
    var block = param.block;
    var ref, ref1;
    var image = block.image, serviceMain = block.serviceMain, serviceSub = block.serviceSub;
    var isMd = (0,useMediaQuery/* default */.Z)(config.md);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                removePaddingMobile: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Services_module_default()).serviceMainImageWrapper,
                    children: [
                        (serviceMain === null || serviceMain === void 0 ? void 0 : (ref = serviceMain.title) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: serviceMain.title.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (Services_module_default()).serviceMainWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Services_module_default()).serviceMainContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            attributes: {
                                                "data-aos": "fade-up"
                                            },
                                            tag: "div",
                                            type: "blue",
                                            text: serviceMain === null || serviceMain === void 0 ? void 0 : (ref1 = serviceMain.title) === null || ref1 === void 0 ? void 0 : ref1.title,
                                            className: (Services_module_default()).title,
                                            icon: isMd ? null : "arrowRightOutline"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-aos": "fade-up",
                                            className: (Services_module_default()).text,
                                            children: serviceMain === null || serviceMain === void 0 ? void 0 : serviceMain.text
                                        })
                                    ]
                                })
                            })
                        }),
                        (image === null || image === void 0 ? void 0 : image.mediaItemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Services_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image.mediaItemUrl,
                                alt: image.altText,
                                width: image.mediaDetails.width,
                                height: image.mediaDetails.height,
                                layout: "responsive",
                                objectFit: "cover",
                                "data-aos": "fade-in"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                removePaddingMobile: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Services_module_default()).servicesSubWrapper,
                    children: [
                        (serviceSub === null || serviceSub === void 0 ? void 0 : serviceSub.length) > 0 && serviceSub.map(function(service, index) {
                            var ref;
                            return service.title.url && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                href: service.title.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (Services_module_default()).serviceSubWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Services_module_default()).serviceSubContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                attributes: {
                                                    "data-aos": "fade-up"
                                                },
                                                tag: "div",
                                                type: "blue",
                                                text: service === null || service === void 0 ? void 0 : (ref = service.title) === null || ref === void 0 ? void 0 : ref.title,
                                                className: (Services_module_default()).title,
                                                icon: isMd ? null : "arrowRightOutline"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-aos": "fade-up",
                                                className: (Services_module_default()).text,
                                                children: service === null || service === void 0 ? void 0 : service.text
                                            })
                                        ]
                                    })
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleAnimation, {})
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Services/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/Teaser/index.ts + 1 modules
var Teaser = __webpack_require__(94543);
// EXTERNAL MODULE: ./components/blocks/custom/Text/Text.module.scss
var Text_Text_module = __webpack_require__(54597);
var Text_Text_module_default = /*#__PURE__*/__webpack_require__.n(Text_Text_module);
;// CONCATENATED MODULE: ./components/blocks/custom/Text/Text.tsx



function Text_Text_Text(param) {
    var block = param.block;
    var text = block.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-aos": "fade-up",
            className: (Text_Text_module_default()).text,
            children: text
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/Text/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/TextLink/TextLink.module.scss
var TextLink_module = __webpack_require__(92894);
var TextLink_module_default = /*#__PURE__*/__webpack_require__.n(TextLink_module);
;// CONCATENATED MODULE: ./components/blocks/custom/TextLink/TextLink.tsx





function TextLink(param) {
    var block = param.block;
    var image = block.image, link = block.link, title = block.title, text = block.text, label = block.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (image === null || image === void 0 ? void 0 : image.mediaItemUrl) ? (TextLink_module_default()).textImageWrapper : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TextLink_module_default()).textWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TextLink_module_default()).titleLabelWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: (TextLink_module_default()).title,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: (TextLink_module_default()).label,
                                    children: label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TextLink_module_default()).textLinkWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: (TextLink_module_default()).text,
                                    dangerouslySetInnerHTML: {
                                        __html: text
                                    }
                                }),
                                (link === null || link === void 0 ? void 0 : link.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    attributes: {
                                        "data-aos": "fade-up"
                                    },
                                    type: "blue",
                                    className: (TextLink_module_default()).button,
                                    text: link.title,
                                    url: link.url,
                                    urlExternal: link.target
                                })
                            ]
                        })
                    ]
                }),
                (image === null || image === void 0 ? void 0 : image.mediaItemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TextLink_module_default()).imageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        "data-aos": "fade-in",
                        src: image.mediaItemUrl,
                        alt: image.altText,
                        width: image.mediaDetails.width,
                        height: image.mediaDetails.height,
                        layout: "responsive"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/TextLink/index.ts


// EXTERNAL MODULE: ./components/blocks/custom/ViewAllPosts/ViewAllPosts.module.scss
var ViewAllPosts_module = __webpack_require__(58079);
var ViewAllPosts_module_default = /*#__PURE__*/__webpack_require__.n(ViewAllPosts_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./functions/utils.js
var utils = __webpack_require__(75265);
;// CONCATENATED MODULE: ./components/blocks/custom/ViewAllPosts/ViewAllPosts.tsx







function ViewAllPosts(param) {
    var block = param.block;
    var ref, ref1, ref2;
    var posts = block.posts;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ViewAllPosts_module_default()).container,
            children: posts === null || posts === void 0 ? void 0 : (ref = posts.data) === null || ref === void 0 ? void 0 : (ref1 = ref.posts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nodes) === null || ref2 === void 0 ? void 0 : ref2.map(function(post, index) {
                var ref, ref1, ref2, ref3;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (ViewAllPosts_module_default()).post,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            post.featuredImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return router.push("/news/".concat(post.slug));
                                },
                                className: (ViewAllPosts_module_default()).image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (ref = post.featuredImage) === null || ref === void 0 ? void 0 : ref.node.mediaItemUrl,
                                    alt: (ref1 = post.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.node.altText,
                                    width: (ref2 = post.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.node.mediaDetails.width,
                                    height: (ref3 = post.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.node.mediaDetails.height,
                                    layout: "responsive",
                                    objectFit: "cover",
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ViewAllPosts_module_default()).textWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ViewAllPosts_module_default()).date,
                                        children: (0,utils/* formatDate */.p)(post.date)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/news/".concat(post.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (ViewAllPosts_module_default()).title,
                                            children: post.title
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }, index);
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/blocks/custom/ViewAllPosts/index.ts


;// CONCATENATED MODULE: ./functions/wordpress/blocks/displayBlock.js









































function displayBlock(block, index) {
    var attributes = block.attributes, name = block.name, innerBlocks = block.innerBlocks;
    switch(name){
        case "core/button":
            return /*#__PURE__*/ (0,react.createElement)(BlockButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/buttons":
            return /*#__PURE__*/ (0,react.createElement)(BlockButtons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                innerBlocks: innerBlocks,
                key: index
            }));
        case "core/code":
        case "core/preformatted":
            return /*#__PURE__*/ (0,react.createElement)(BlockCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/columns":
            return /*#__PURE__*/ (0,react.createElement)(BlockColumns, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                innerBlocks: innerBlocks,
                key: index
            }));
        case "core/cover":
            return /*#__PURE__*/ (0,react.createElement)(BlockCover, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                innerBlocks: innerBlocks,
                key: index
            }));
        case "core/embed":
            return /*#__PURE__*/ (0,react.createElement)(BlockEmbed, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/gallery":
            return /*#__PURE__*/ (0,react.createElement)(BlockImageGallery, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/heading":
            return /*#__PURE__*/ (0,react.createElement)(BlockHeadings, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/image":
            return /*#__PURE__*/ (0,react.createElement)(BlockImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/list":
            return /*#__PURE__*/ (0,react.createElement)(BlockList, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/media-text":
            return /*#__PURE__*/ (0,react.createElement)(BlockMediaText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                innerBlocks: innerBlocks,
                key: index
            }));
        case "core/paragraph":
            return /*#__PURE__*/ (0,react.createElement)(BlockParagraph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/pullquote":
            return /*#__PURE__*/ (0,react.createElement)(BlockPullQuote, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/quote":
            return /*#__PURE__*/ (0,react.createElement)(BlockQuote, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/separator":
            return /*#__PURE__*/ (0,react.createElement)(BlockSeparator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/spacer":
            return /*#__PURE__*/ (0,react.createElement)(BlockSpacer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/table":
            return /*#__PURE__*/ (0,react.createElement)(BlockTable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "core/video":
            return /*#__PURE__*/ (0,react.createElement)(BlockVideo_Video, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "gravityforms/form":
            return /*#__PURE__*/ (0,react.createElement)(BlockGravityForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/intro":
            return /*#__PURE__*/ (0,react.createElement)(Intro, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/services":
            return /*#__PURE__*/ (0,react.createElement)(Services, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/facts":
            return /*#__PURE__*/ (0,react.createElement)(Facts, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/faqs":
            return /*#__PURE__*/ (0,react.createElement)(FAQs, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/image-text":
            return /*#__PURE__*/ (0,react.createElement)(ImageText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/text-link":
            return /*#__PURE__*/ (0,react.createElement)(TextLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/locations":
            return /*#__PURE__*/ (0,react.createElement)(Locations, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/teaser":
            return /*#__PURE__*/ (0,react.createElement)(Teaser/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/image-link":
            return /*#__PURE__*/ (0,react.createElement)(ImageLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/text":
            return /*#__PURE__*/ (0,react.createElement)(Text_Text_Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/logos":
            return /*#__PURE__*/ (0,react.createElement)(Logos, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/contacts":
            return /*#__PURE__*/ (0,react.createElement)(Contacts, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/locations-links":
            return /*#__PURE__*/ (0,react.createElement)(LocationsLinks_Locations, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/label":
            return /*#__PURE__*/ (0,react.createElement)(Label_Intro, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/image":
            return /*#__PURE__*/ (0,react.createElement)(ImageBlock, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/all-posts":
            return /*#__PURE__*/ (0,react.createElement)(RelatedPosts/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        case "acf/view-all-posts":
            return /*#__PURE__*/ (0,react.createElement)(ViewAllPosts, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                key: index
            }));
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                children: JSON.stringify(block, null, 2)
            }, index);
    }
}
displayBlock.propTypes = {
    block: (prop_types_default()).object.isRequired,
    index: (prop_types_default()).number.isRequired
};

;// CONCATENATED MODULE: ./components/molecules/Blocks/Blocks.js



/**
 * Render the Blocks component.
 *
 * @author WebDevStudios
 * @param  {object}  props        The component attributes as props.
 * @param  {Array}   props.blocks The array of blocks.
 * @return {Element}              The Blocks component.
 */ function Blocks(param) {
    var blocks = param.blocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: // If there are blocks, loop over and display.
        !!(blocks === null || blocks === void 0 ? void 0 : blocks.length) && blocks.map(function(block, index) {
            return block.innerBlocks.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks, {
                blocks: block.innerBlocks
            }, index) : displayBlock(block, index);
        })
    });
}
Blocks.propTypes = {
    blocks: (prop_types_default()).array.isRequired
};
Blocks.defaultProps = {
    blocks: []
};

;// CONCATENATED MODULE: ./components/molecules/Blocks/index.js



/***/ }),

/***/ 75265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export slugify */
var slugify = function(str) {
    return str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
};
var formatDate = function(timestamp) {
    var date = new Date(timestamp);
    var day = date.getDate().toString().padStart(2, "0");
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var year = date.getFullYear().toString();
    return "".concat(day, ".").concat(month, ".").concat(year);
};


/***/ }),

/***/ 90848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nr": function() { return /* binding */ initializeNextApiApollo; },
  "PO": function() { return /* binding */ nextApiRoutes; }
});

// UNUSED EXPORTS: createNextApiApolloClient

;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/encodeGfFormData.js
/**
 * Encode GF form data into multipart form data.
 *
 * @param  {object} data GF form data.
 * @return {object}      Encoded form data.
 */ function encodeGfFormData(data) {
    var formData = new FormData();
    formData.append("formId", data === null || data === void 0 ? void 0 : data.formId);
    if (!(data === null || data === void 0 ? void 0 : data.fieldValues) || !(data === null || data === void 0 ? void 0 : data.fieldValues.length)) {
        return {
            body: formData
        };
    }
    data.fieldValues.forEach(function(field) {
        // Check if field is file upload field.
        if (field === null || field === void 0 ? void 0 : field.fileUploadValues) {
            // Pass uploaded file data.
            formData.append("field_".concat(field.id), field.fileUploadValues);
        } else {
            // Pass stringified version of full field object for all other field types.
            formData.append("field_".concat(field.id), JSON.stringify(field));
        }
    });
    return {
        body: formData
    };
}

// EXTERNAL MODULE: ./lib/apolloConfig.js
var apolloConfig = __webpack_require__(91467);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./lib/next-api/wordpress/_config/schema.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scalar Upload\n\n  type AddressInput {\n    street: String\n    lineTwo: String\n    city: String\n    state: String\n    zip: String\n    country: String\n  }\n\n  type ChainedSelectInput {\n    inputId: Float\n    value: String\n  }\n\n  type CheckboxInput {\n    inputId: Float\n    value: String\n  }\n\n  type ListInput {\n    values: [String]\n    rowValues: [String]\n  }\n\n  type NameInput {\n    prefix: String\n    first: String\n    middle: String\n    last: String\n    suffix: String\n  }\n\n  type Upload {\n    name: String\n    type: String\n    size: Int\n    tmp_name: String\n  }\n\n  type FieldValuesInput {\n    id: Int!\n    addressValues: AddressInput\n    chainedSelectValues: [ChainedSelectInput]\n    checkboxValues: [CheckboxInput]\n    fileUploadValues: Upload\n    listValues: [ListInput]\n    nameValues: NameInput\n    values: [String]\n    value: String\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// Define WP Next.js API GraphQL schema.
var typeDefs = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 4 modules
var ApolloClient = __webpack_require__(16615);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 5 modules
var inMemoryCache = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/apollo-link-rest/bundle.umd.js
var bundle_umd = __webpack_require__(20054);
;// CONCATENATED MODULE: ./lib/next-api/connector.js





var nextApiApolloClient;
// Define API route bases.
var nextApiRouteBases = {
    wordpress: "/wordpress"
};
// Define API routes.
var nextApiRoutes = {
    wordpress: {
        archive: "".concat(nextApiRouteBases.wordpress, "/archive"),
        comments: "".concat(nextApiRouteBases.wordpress, "/comments"),
        gravityForms: "".concat(nextApiRouteBases.wordpress, "/gravityForms")
    }
};
// Define Next.js API route link.
var restLink = new bundle_umd.RestLink({
    uri: "/api",
    bodySerializers: {
        encodeGfFormData: encodeGfFormData
    }
});
/**
 * Create a basic Apollo client for connecting to Next.js API Routes.
 *
 * @see https://www.apollographql.com/docs/react/api/core/ApolloClient/
 * @author WebDevStudios
 * @return {object} Apollo client instance.
 */ function createNextApiApolloClient() {
    return new ApolloClient/* ApolloClient */.f({
        ssrMode: false,
        link: restLink,
        cache: new inMemoryCache/* InMemoryCache */.h(),
        // TODO: figure out how to combine multiple type defs (i.e., WP and other APIs) and pass as single prop here.
        typeDefs: typeDefs
    });
}
/**
 * Init Apollo for Next.js API and merge with initial state.
 *
 * @author WebDevStudios
 * @param  {*}      initialState Initial Apollo state.
 * @return {object}              Next.js API Apollo client instance.
 */ function initializeNextApiApollo() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    // Only run one instance of the Apollo client.
    var _apolloClient = nextApiApolloClient !== null && nextApiApolloClient !== void 0 ? nextApiApolloClient : createNextApiApolloClient();
    var newApolloClient = (0,apolloConfig/* initializeApollo */["in"])(_apolloClient, initialState);
    // For SSG and SSR always create a new Apollo Client.
    if (false) {}
    // Create the Apollo Client once in the client.
    if (!nextApiApolloClient) nextApiApolloClient = newApolloClient;
    return newApolloClient;
}


/***/ }),

/***/ 73718:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__0CDcu","columnStacked":"Columns_columnStacked__pCmbh","alignCenter":"Columns_alignCenter__VTd2X","column":"Columns_column__pc6MX","alignBottom":"Columns_alignBottom__A_sx_","hasBackground":"Columns_hasBackground__GlI9h"};

/***/ }),

/***/ 71858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image____yYi","caption":"Image_caption__KsINX","hasImageFill":"Image_hasImageFill__Ku0gV","imageFill":"Image_imageFill__PpUvD"};

/***/ }),

/***/ 26821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pullquote":"PullQuote_pullquote__bOEWA","styleSolid":"PullQuote_styleSolid__O021I","wrap":"PullQuote_wrap__XBekL"};

/***/ }),

/***/ 80892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__Od1gY"};

/***/ }),

/***/ 58326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__xMSux"};

/***/ }),

/***/ 16997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__dUHP2","caption":"Table_caption__Jwkqz"};

/***/ }),

/***/ 56491:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"VideoEmbed_videoEmbed__DdpE5","wrapper":"VideoEmbed_wrapper__Ba15J","caption":"VideoEmbed_caption__0ePZF"};

/***/ }),

/***/ 27458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ButtonGroup_buttonGroup__KCqGf","horizontal":"ButtonGroup_horizontal__eTBxN","vertical":"ButtonGroup_vertical__zcoUL","center":"ButtonGroup_center__W0aaZ","right":"ButtonGroup_right__g1SKr"};

/***/ }),

/***/ 44155:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"ImageGallery_gallery__O08SW","wrap":"ImageGallery_wrap__SyHj1","columns-1":"ImageGallery_columns-1___wrh_","columns-2":"ImageGallery_columns-2__osKTF","columns-3":"ImageGallery_columns-3__vrRUe","columns-4":"ImageGallery_columns-4__s248B","columns-5":"ImageGallery_columns-5__KQvQn","columns-6":"ImageGallery_columns-6__SIIsp","imageWrap":"ImageGallery_imageWrap__V5R6K","caption":"ImageGallery_caption__1_wDR"};

/***/ }),

/***/ 19129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__d74YO","alignLeft":"Hero_alignLeft__RzZdQ","alignRight":"Hero_alignRight__Vjyjv","contentAlignTop":"Hero_contentAlignTop__Hi7KJ","contentAlignBottom":"Hero_contentAlignBottom__MUBuH","contentAlignLeft":"Hero_contentAlignLeft__LiKX9","contentAlignRight":"Hero_contentAlignRight__irMYM","fixed":"Hero_fixed__xybj_","fullHeight":"Hero_fullHeight__QvrHt","repeat":"Hero_repeat___xxO0","content":"Hero_content__IOrwX","subtitle":"Hero_subtitle__NdNYo","title":"Hero_title__cfraI","body":"Hero_body__EB0O_","button":"Hero_button__3R2dq","overlay":"Hero_overlay___rAiK","overlayOnly":"Hero_overlayOnly__QFKZo","filterImage":"Hero_filterImage__ZGXla","filter":"Hero_filter__DKhzy"};

/***/ }),

/***/ 83622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mediaText":"MediaText_mediaText__pP1Qu","noStack":"MediaText_noStack__jC26V","text":"MediaText_text__kPSd6","media":"MediaText_media__Bvqdt","title":"MediaText_title__q9RE0","body":"MediaText_body__o9dvK","imageWrap":"MediaText_imageWrap__jHdAj","mediaLeft":"MediaText_mediaLeft__RCCF6","alignTop":"MediaText_alignTop__CovWF","alignBottom":"MediaText_alignBottom__wHNTn","imageFill":"MediaText_imageFill__tsPM_"};

/***/ }),

/***/ 8407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle":"CircleAnimation_circle__Bial6","circleContainer":"CircleAnimation_circleContainer__aUXFl","scale":"CircleAnimation_scale__m_6HP"};

/***/ }),

/***/ 63865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visual":"EllipseAnimation_visual__V3VD_","round":"EllipseAnimation_round__aMBfa","wrapper":"EllipseAnimation_wrapper__KSj6M","circle":"EllipseAnimation_circle__Qa4Dx","scale":"EllipseAnimation_scale__6Y132"};

/***/ }),

/***/ 5297:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__OfBJB","scale":"Checkbox_scale___GXaS"};

/***/ }),

/***/ 33638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputError":"InputError_inputError__ePtF9","scale":"InputError_scale__7rBU3"};

/***/ }),

/***/ 92558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__1uaJ2","isError":"Select_isError__KiuHZ","selectWrapper":"Select_selectWrapper__tsAIz","container":"Select_container__I_RUT","scale":"Select_scale__imQLQ"};

/***/ }),

/***/ 4477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__qCVSB","scale":"Text_scale__d1aPN"};

/***/ }),

/***/ 88745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"Label_titleWrapper__Iv3cf","isSmall":"Label_isSmall__EUyup","paddingTop":"Label_paddingTop__aKXqH","title":"Label_title__MlGr0","button":"Label_button__yQAzG","scale":"Label_scale__b46S7"};

/***/ }),

/***/ 80937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"SquareAnimation_grid__vBMZV","gridWrapper":"SquareAnimation_gridWrapper__WT21x","imageAnimationWrapper":"SquareAnimation_imageAnimationWrapper__9OXSs","animation":"SquareAnimation_animation__NVfXz","scale":"SquareAnimation_scale__5XhSU"};

/***/ }),

/***/ 79041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video___6UHx","isPlaying":"Video_isPlaying__PcCi3","icon":"Video_icon__u6tmY","loading":"Video_loading__vScsu","scale":"Video_scale__W2pci"};

/***/ }),

/***/ 27772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video_videoWrapper__WgIcB","scale":"Video_scale___iV1r"};

/***/ }),

/***/ 35426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Contacts_text__UxKQR","fadeIn":"Contacts_fadeIn__6m6vH","fadeOut":"Contacts_fadeOut__GbQLo","labelWrapper":"Contacts_labelWrapper__ghtIh","tabs":"Contacts_tabs__YIg48","listWrapper":"Contacts_listWrapper__VTENh","title":"Contacts_title__2oB5s","isactive":"Contacts_isactive__JJycg","arrowMove":"Contacts_arrowMove__nENo5","contacts":"Contacts_contacts___eqkV","scale":"Contacts_scale__ffwDp"};

/***/ }),

/***/ 91905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQs_wrapper__hT1bh","isHighlights":"FAQs_isHighlights__DG2ei","faqsWrapper":"FAQs_faqsWrapper__ZcvnQ","faqWrapper":"FAQs_faqWrapper__LGESB","labelWrapper":"FAQs_labelWrapper__kUEk8","question":"FAQs_question__9wb6t","isActive":"FAQs_isActive__7oWJm","questionWrapper":"FAQs_questionWrapper__3iuux","plusIcon":"FAQs_plusIcon__5FyHn","isOpen":"FAQs_isOpen__KwHR_","answer":"FAQs_answer__rrJyp","answerWrapper":"FAQs_answerWrapper__EXVGV","button":"FAQs_button__MLA2J","animationWrapper":"FAQs_animationWrapper__ps8bF","scale":"FAQs_scale__00hfb"};

/***/ }),

/***/ 35497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Facts_imageWrapper__C8VpH","factsWrapper":"Facts_factsWrapper__umEHX","factsContainer":"Facts_factsContainer__NURhL","factTitle":"Facts_factTitle__pCUse","factText":"Facts_factText__so2Lj","imageFactsWrapper":"Facts_imageFactsWrapper__SI9gh","scale":"Facts_scale__YCfpG"};

/***/ }),

/***/ 64147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__tF3gQ","imageAnimationWrapper":"Image_imageAnimationWrapper__MreZP","scale":"Image_scale__dehiU"};

/***/ }),

/***/ 91243:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"ImageLink_imageWrapper__CbLnW","textWrapper":"ImageLink_textWrapper__gOwk9","card":"ImageLink_card__e0h21","imageLink":"ImageLink_imageLink__Adr0T","button":"ImageLink_button___IoAZ","text":"ImageLink_text__Cwt2l","scale":"ImageLink_scale__DbUfQ"};

/***/ }),

/***/ 55217:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageTextWrapper":"ImageText_imageTextWrapper__PYdug","onlyChild":"ImageText_onlyChild__UkRNO","imageContainer":"ImageText_imageContainer__qA0RZ","removePaddingBottom":"ImageText_removePaddingBottom__Q0xcS","button":"ImageText_button__F3k6u","title":"ImageText_title__fRw61","label":"ImageText_label___9TYW","text":"ImageText_text__vh2R1","textWrapper":"ImageText_textWrapper__gp1J1","textContainer":"ImageText_textContainer__rCE8Y","scale":"ImageText_scale__Mfr_F"};

/***/ }),

/***/ 12250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Intro_text__M5D2Y","textWrapper":"Intro_textWrapper__1Z152","textContainer":"Intro_textContainer__IWMGP","intro":"Intro_intro__R68Dn","scale":"Intro_scale__bj1fz"};

/***/ }),

/***/ 66264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"serviceSubContainer":"Locations_serviceSubContainer__s0EJH","servicesSubWrapper":"Locations_servicesSubWrapper__bKoYi","title":"Locations_title__P2eeB","text":"Locations_text__Q_cmi","serviceSubWrapper":"Locations_serviceSubWrapper__H1EgP","scale":"Locations_scale___kg3K"};

/***/ }),

/***/ 40008:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"LocationsLinks_textWrapper__qdN8R","locationsLinks":"LocationsLinks_locationsLinks__o9ixy","imageWrapper":"LocationsLinks_imageWrapper__NW0QC","title":"LocationsLinks_title__9hiAl","subtitle":"LocationsLinks_subtitle__U5_H7","address":"LocationsLinks_address__bvWWT","locationsWrapper":"LocationsLinks_locationsWrapper__P_Y5p","location":"LocationsLinks_location__owY7V","animationWrapper":"LocationsLinks_animationWrapper__aw7Wc","scale":"LocationsLinks_scale__MKch3"};

/***/ }),

/***/ 42531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logos":"Logos_logos__fhqS7","imageWrapper":"Logos_imageWrapper__zBFnQ","imageContainer":"Logos_imageContainer__lHW1o","image":"Logos_image___hsRV","scale":"Logos_scale__W7D19"};

/***/ }),

/***/ 20717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"relatedPostsWrapper":"RelatedPosts_relatedPostsWrapper__4fowU","noSliderButtons":"RelatedPosts_noSliderButtons__uzTPe","sliderWrapper":"RelatedPosts_sliderWrapper__xQNC7","slideImage":"RelatedPosts_slideImage__Hfz0s","slideSubtitle":"RelatedPosts_slideSubtitle__GZOp5","slideTitle":"RelatedPosts_slideTitle__6Xm5o","date":"RelatedPosts_date__ZHjTv","scale":"RelatedPosts_scale___MXji"};

/***/ }),

/***/ 59843:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"serviceMainContainer":"Services_serviceMainContainer__z4dl7","title":"Services_title__8Egeh","text":"Services_text__W3z5d","serviceMainWrapper":"Services_serviceMainWrapper__r7dzp","serviceSubWrapper":"Services_serviceSubWrapper__8TqI8","imageWrapper":"Services_imageWrapper__Ivl_0","serviceMainImageWrapper":"Services_serviceMainImageWrapper__bLrK_","serviceSubContainer":"Services_serviceSubContainer__UcMbi","servicesSubWrapper":"Services_servicesSubWrapper__rcf1k","scale":"Services_scale__Ru0Hq"};

/***/ }),

/***/ 54597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__LZBl9","scale":"Text_scale__6N_4T"};

/***/ }),

/***/ 92894:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"TextLink_title__AlQMZ","label":"TextLink_label__p2mjL","text":"TextLink_text__KaB86","textWrapper":"TextLink_textWrapper__6e2a_","button":"TextLink_button__88qi4","titleLabelWrapper":"TextLink_titleLabelWrapper__aIrXI","textLinkWrapper":"TextLink_textLinkWrapper__pp9iv","imageContainer":"TextLink_imageContainer___9F3R","textImageWrapper":"TextLink_textImageWrapper__7hgVp","scale":"TextLink_scale__iEpXu"};

/***/ }),

/***/ 58079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewAllPosts_container__06b07","post":"ViewAllPosts_post__3gG0X","image":"ViewAllPosts_image__zyu_o","subtitle":"ViewAllPosts_subtitle__MWzfO","title":"ViewAllPosts_title__8BFsT","date":"ViewAllPosts_date__8UCsV","scale":"ViewAllPosts_scale__CPUlB"};

/***/ }),

/***/ 51518:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"consent":"Consent_consent__OXgdp","scale":"Consent_scale__xPMn6"};

/***/ }),

/***/ 20297:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"isHidden":"File_isHidden__XUvt8","fileWrapper":"File_fileWrapper__MW569","file":"File_file__T3_W_","filePlaceholder":"File_filePlaceholder__5M6bO","hasError":"File_hasError__tOCJg","showLabel":"File_showLabel__3gc8J","container":"File_container__hdNML","scale":"File_scale__98_E0"};

/***/ }),

/***/ 70829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"Section_label__KRvw6","scale":"Section_scale__Y_7G_"};

/***/ }),

/***/ 96144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"Text_textWrapper__ijD1j","scale":"Text_scale__muLpD"};

/***/ }),

/***/ 57278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scale":"GravityForm_scale__zZodU"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);